function PlanA({ ...props }) {
	return (
		<g {...props} id="unit-a">
			<g id="furniture">
				<polyline
					points="718.93 857.06 713.78 857.06 713.78 854.45 718.93 854.45 718.93 857.06"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="783.38 628.44 783.38 851.84 727.32 851.84 727.32 628.44 783.38 628.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="508.92 785.82 508.92 897.48 543.96 897.48 543.96 785.82 508.92 785.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="543.96"
					y1="785.82"
					x2="508.92"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.96"
					y1="897.48"
					x2="543.96"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="897.48"
					x2="543.96"
					y2="897.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="785.82"
					x2="508.92"
					y2="897.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="785.82"
					x2="508.92"
					y2="790.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="794"
					x2="508.92"
					y2="799.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="802.97"
					x2="508.92"
					y2="808.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="811.94"
					x2="508.92"
					y2="817.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="820.91"
					x2="508.92"
					y2="826.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="829.88"
					x2="508.92"
					y2="835.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="838.85"
					x2="508.92"
					y2="844.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="847.82"
					x2="508.92"
					y2="853.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="856.79"
					x2="508.92"
					y2="862.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="865.76"
					x2="508.92"
					y2="871.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="874.72"
					x2="508.92"
					y2="880.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="883.69"
					x2="508.92"
					y2="889.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="892.66"
					x2="508.92"
					y2="897.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="508.92"
					y1="897.48"
					x2="514.62"
					y2="897.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.99"
					y1="897.48"
					x2="523.59"
					y2="897.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="526.95"
					y1="897.48"
					x2="532.56"
					y2="897.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.92"
					y1="897.48"
					x2="541.62"
					y2="897.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="897.48"
					x2="541.62"
					y2="892.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="889.3"
					x2="541.62"
					y2="883.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="880.33"
					x2="541.62"
					y2="874.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="871.36"
					x2="541.62"
					y2="865.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="862.39"
					x2="541.62"
					y2="856.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="853.42"
					x2="541.62"
					y2="847.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="844.45"
					x2="541.62"
					y2="838.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="835.48"
					x2="541.62"
					y2="829.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="826.52"
					x2="541.62"
					y2="820.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="817.55"
					x2="541.62"
					y2="811.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="808.58"
					x2="541.62"
					y2="802.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="799.61"
					x2="541.62"
					y2="794"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="790.64"
					x2="541.62"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.62"
					y1="785.82"
					x2="535.92"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.56"
					y1="785.82"
					x2="526.95"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.59"
					y1="785.82"
					x2="517.99"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="514.62"
					y1="785.82"
					x2="508.92"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="246.51 483.99 418.59 483.99 418.59 448.96 246.51 448.96 246.51 483.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="246.51"
					y1="448.96"
					x2="246.51"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="448.96"
					x2="246.51"
					y2="448.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="483.99"
					x2="418.59"
					y2="448.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.51"
					y1="483.99"
					x2="418.59"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.51"
					y1="483.99"
					x2="250.15"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.51"
					y1="483.99"
					x2="259.12"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.48"
					y1="483.99"
					x2="268.09"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.45"
					y1="483.99"
					x2="277.06"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.42"
					y1="483.99"
					x2="286.02"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.39"
					y1="483.99"
					x2="294.99"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.36"
					y1="483.99"
					x2="303.96"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.33"
					y1="483.99"
					x2="312.93"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.29"
					y1="483.99"
					x2="321.9"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.26"
					y1="483.99"
					x2="330.87"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.23"
					y1="483.99"
					x2="339.84"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.2"
					y1="483.99"
					x2="348.81"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.17"
					y1="483.99"
					x2="357.78"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.14"
					y1="483.99"
					x2="366.74"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.11"
					y1="483.99"
					x2="375.72"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.08"
					y1="483.99"
					x2="384.68"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.05"
					y1="483.99"
					x2="393.65"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.02"
					y1="483.99"
					x2="402.62"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.98"
					y1="483.99"
					x2="411.59"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="414.96"
					y1="483.99"
					x2="418.59"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="483.99"
					x2="418.59"
					y2="478.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="474.93"
					x2="418.59"
					y2="469.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="465.96"
					x2="418.59"
					y2="460.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="457"
					x2="418.59"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="451.3"
					x2="414.96"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="411.59"
					y1="451.3"
					x2="405.98"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.62"
					y1="451.3"
					x2="397.02"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.65"
					y1="451.3"
					x2="388.05"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.68"
					y1="451.3"
					x2="379.08"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.72"
					y1="451.3"
					x2="370.11"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.74"
					y1="451.3"
					x2="361.14"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.78"
					y1="451.3"
					x2="352.17"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.81"
					y1="451.3"
					x2="343.2"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.84"
					y1="451.3"
					x2="334.23"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.87"
					y1="451.3"
					x2="325.26"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="321.9"
					y1="451.3"
					x2="316.29"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.93"
					y1="451.3"
					x2="307.33"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.96"
					y1="451.3"
					x2="298.36"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.99"
					y1="451.3"
					x2="289.39"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.02"
					y1="451.3"
					x2="280.42"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.06"
					y1="451.3"
					x2="271.45"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.09"
					y1="451.3"
					x2="262.48"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.12"
					y1="451.3"
					x2="253.51"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.15"
					y1="451.3"
					x2="246.51"
					y2="451.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.51"
					y1="451.3"
					x2="246.51"
					y2="457"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.51"
					y1="460.36"
					x2="246.51"
					y2="465.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.51"
					y1="469.33"
					x2="246.51"
					y2="474.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.51"
					y1="478.3"
					x2="246.51"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="579.4 766.96 521.7 766.96 521.7 709.26 579.4 709.26 579.4 766.96"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="202.19"
					y1="664.48"
					x2="202.19"
					y2="528.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="508.92"
					y1="897.48"
					x2="508.92"
					y2="785.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="948.83"
					x2="578.51"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="930.15"
					x2="578.51"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="930.15"
					x2="582.02"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="948.83"
					x2="674.28"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="930.15"
					x2="674.28"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="930.15"
					x2="670.77"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="669.6 950 674.28 950 674.28 948.83 669.6 948.83 669.6 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.18 948.83 578.51 948.83 578.51 950 583.18 950 583.18 948.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="669.6 930.15 674.28 930.15 674.28 928.98 669.6 928.98 669.6 930.15"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.18 928.98 578.51 928.98 578.51 930.15 583.18 930.15 583.18 928.98"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="669.6"
					y1="950"
					x2="674.28"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.28"
					y1="950"
					x2="674.28"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.28"
					y1="948.83"
					x2="669.6"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.6"
					y1="948.83"
					x2="669.6"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.18"
					y1="948.83"
					x2="578.51"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.51"
					y1="948.83"
					x2="578.51"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.51"
					y1="950"
					x2="583.18"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.18"
					y1="950"
					x2="583.18"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.6"
					y1="930.15"
					x2="674.28"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.28"
					y1="930.15"
					x2="674.28"
					y2="928.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.28"
					y1="928.98"
					x2="669.6"
					y2="928.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.6"
					y1="928.98"
					x2="669.6"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.18"
					y1="928.98"
					x2="578.51"
					y2="928.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.51"
					y1="928.98"
					x2="578.51"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.51"
					y1="930.15"
					x2="583.18"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.18"
					y1="930.15"
					x2="583.18"
					y2="928.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="668.44 948.83 670.19 948.83 670.19 930.15 668.44 930.15 668.44 948.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="582.6 948.83 584.35 948.83 584.35 930.15 582.6 930.15 582.6 948.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="643.81 870.69 584.35 930.15 587.24 933.04 646.7 873.58 643.81 870.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="670.19"
					y1="930.15"
					x2="670.77"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.19"
					y1="948.83"
					x2="670.77"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.77"
					y1="930.15"
					x2="670.77"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.6"
					y1="930.15"
					x2="582.02"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.6"
					y1="948.83"
					x2="582.02"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.02"
					y1="930.15"
					x2="582.02"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.44"
					y1="948.83"
					x2="668.44"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.44"
					y1="930.15"
					x2="670.19"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.19"
					y1="930.15"
					x2="670.19"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.19"
					y1="948.83"
					x2="668.44"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.6"
					y1="948.83"
					x2="582.6"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.6"
					y1="930.15"
					x2="584.35"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.35"
					y1="930.15"
					x2="584.35"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.35"
					y1="948.83"
					x2="582.6"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.81"
					y1="870.69"
					x2="646.7"
					y2="873.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.7"
					y1="873.58"
					x2="587.24"
					y2="933.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.24"
					y1="933.04"
					x2="584.35"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.35"
					y1="930.15"
					x2="643.81"
					y2="870.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.77"
					y1="930.15"
					x2="670.77"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="930.15"
					x2="670.77"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="930.15"
					x2="674.28"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="930.15"
					x2="674.28"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="948.83"
					x2="674.28"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="670.77"
					y1="948.83"
					x2="674.28"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="930.15"
					x2="582.02"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="930.15"
					x2="582.02"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="930.15"
					x2="578.51"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="930.15"
					x2="578.51"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="948.83"
					x2="578.51"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="582.02"
					y1="948.83"
					x2="578.51"
					y2="948.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="803.81"
					y1="851.84"
					x2="803.81"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="583.86"
					y1="768.58"
					x2="583.86"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="768.58"
					x2="595.54"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="768.58"
					x2="583.86"
					y2="768.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="583.86"
					y1="707.86"
					x2="583.86"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="707.86"
					x2="595.54"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="707.86"
					x2="583.86"
					y2="707.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="583.86"
					y1="702.3"
					x2="583.86"
					y2="707.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="582.69 709.02 583.86 709.02 583.86 704.35 582.69 704.35 582.69 709.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.86 767.41 582.69 767.41 582.69 772.09 583.86 772.09 583.86 767.41"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="595.54 709.02 596.71 709.02 596.71 704.35 595.54 704.35 595.54 709.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="596.71 767.41 595.54 767.41 595.54 772.09 596.71 772.09 596.71 767.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="582.69"
					y1="709.02"
					x2="582.69"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.69"
					y1="704.35"
					x2="583.86"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="704.35"
					x2="583.86"
					y2="709.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="709.02"
					x2="582.69"
					y2="709.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="767.41"
					x2="583.86"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="772.09"
					x2="582.69"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.69"
					y1="772.09"
					x2="582.69"
					y2="767.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.69"
					y1="767.41"
					x2="583.86"
					y2="767.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="709.02"
					x2="595.54"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="704.35"
					x2="596.71"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.71"
					y1="704.35"
					x2="596.71"
					y2="709.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.71"
					y1="709.02"
					x2="595.54"
					y2="709.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.71"
					y1="767.41"
					x2="596.71"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="596.71"
					y1="772.09"
					x2="595.54"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="772.09"
					x2="595.54"
					y2="767.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="767.41"
					x2="596.71"
					y2="767.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="583.86 710.19 595.54 710.19 595.54 708.44 583.86 708.44 583.86 710.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="583.86 768 595.54 768 595.54 766.25 583.86 766.25 583.86 768"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="635.18 726.61 632.29 723.72 592.65 763.36 595.54 766.25 635.18 726.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="595.54"
					y1="708.44"
					x2="595.54"
					y2="707.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="708.44"
					x2="583.86"
					y2="707.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="707.86"
					x2="583.86"
					y2="707.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="768"
					x2="595.54"
					y2="768.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="768"
					x2="583.86"
					y2="768.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="768.58"
					x2="583.86"
					y2="768.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="710.19"
					x2="595.54"
					y2="710.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="710.19"
					x2="595.54"
					y2="708.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="708.44"
					x2="583.86"
					y2="708.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="708.44"
					x2="583.86"
					y2="710.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="768"
					x2="595.54"
					y2="768"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="768"
					x2="595.54"
					y2="766.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="766.25"
					x2="583.86"
					y2="766.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="583.86"
					y1="766.25"
					x2="583.86"
					y2="768"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="635.18"
					y1="726.61"
					x2="632.29"
					y2="723.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.29"
					y1="723.72"
					x2="592.65"
					y2="763.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.65"
					y1="763.36"
					x2="595.54"
					y2="766.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="766.25"
					x2="635.18"
					y2="726.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="595.54"
					y1="707.86"
					x2="583.86"
					y2="707.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="707.86"
					x2="583.86"
					y2="707.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="707.86"
					x2="595.54"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="707.86"
					x2="595.54"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="583.86"
					y1="707.86"
					x2="583.86"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="583.86"
					y1="707.86"
					x2="583.86"
					y2="704.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="768.58"
					x2="583.86"
					y2="768.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="768.58"
					x2="583.86"
					y2="768.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="768.58"
					x2="595.54"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="595.54"
					y1="768.58"
					x2="595.54"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="583.86"
					y1="768.58"
					x2="583.86"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="583.86"
					y1="768.58"
					x2="583.86"
					y2="772.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="783.38"
					y1="851.84"
					x2="803.81"
					y2="851.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="551.44"
					x2="559.2"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="559.2"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="562.7"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="551.44"
					x2="544.31"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="539.76"
					x2="544.31"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="539.76"
					x2="540.81"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="551.44"
					x2="453.22"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="539.76"
					x2="453.22"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="539.76"
					x2="456.72"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="557.56"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="545.88"
					y1="539.76"
					x2="540.81"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="563.87 551.44 559.2 551.44 559.2 552.61 563.87 552.61 563.87 551.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="563.87 538.59 559.2 538.59 559.2 539.76 563.87 539.76 563.87 538.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="563.87"
					y1="551.44"
					x2="559.2"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.2"
					y1="551.44"
					x2="559.2"
					y2="552.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.2"
					y1="552.61"
					x2="563.87"
					y2="552.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.87"
					y1="552.61"
					x2="563.87"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.87"
					y1="538.59"
					x2="559.2"
					y2="538.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.2"
					y1="538.59"
					x2="559.2"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.2"
					y1="539.76"
					x2="563.87"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.87"
					y1="539.76"
					x2="563.87"
					y2="538.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="563.28 551.44 565.04 551.44 565.04 539.76 563.28 539.76 563.28 551.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="621.19 483.61 565.04 539.76 567.93 542.65 624.08 486.5 621.19 483.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="563.28"
					y1="539.76"
					x2="562.7"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.28"
					y1="551.44"
					x2="562.7"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="562.7"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.28"
					y1="551.44"
					x2="563.28"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.28"
					y1="539.76"
					x2="565.04"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.04"
					y1="539.76"
					x2="565.04"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.04"
					y1="551.44"
					x2="563.28"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="621.19"
					y1="483.61"
					x2="624.08"
					y2="486.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="624.08"
					y1="486.5"
					x2="567.93"
					y2="542.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.93"
					y1="542.65"
					x2="565.04"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="565.04"
					y1="539.76"
					x2="621.19"
					y2="483.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="562.7"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="562.7"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="559.2"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="539.76"
					x2="559.2"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="551.44"
					x2="559.2"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.7"
					y1="551.44"
					x2="559.2"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="457.89 552.61 457.89 551.44 453.22 551.44 453.22 552.61 457.89 552.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="539.64 551.44 539.64 552.61 544.31 552.61 544.31 551.44 539.64 551.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="457.89 539.76 457.89 538.59 453.22 538.59 453.22 539.76 457.89 539.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="539.64 538.59 539.64 539.76 544.31 539.76 544.31 538.59 539.64 538.59"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="457.89"
					y1="552.61"
					x2="453.22"
					y2="552.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.22"
					y1="552.61"
					x2="453.22"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.22"
					y1="551.44"
					x2="457.89"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.89"
					y1="551.44"
					x2="457.89"
					y2="552.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.64"
					y1="551.44"
					x2="544.31"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="551.44"
					x2="544.31"
					y2="552.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="552.61"
					x2="539.64"
					y2="552.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.64"
					y1="552.61"
					x2="539.64"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.89"
					y1="539.76"
					x2="453.22"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.22"
					y1="539.76"
					x2="453.22"
					y2="538.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.22"
					y1="538.59"
					x2="457.89"
					y2="538.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.89"
					y1="538.59"
					x2="457.89"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.64"
					y1="538.59"
					x2="544.31"
					y2="538.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="538.59"
					x2="544.31"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.31"
					y1="539.76"
					x2="539.64"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="539.64"
					y1="539.76"
					x2="539.64"
					y2="538.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="459.06 551.44 459.06 539.76 457.31 539.76 457.31 551.44 459.06 551.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="540.22 551.44 540.22 539.76 538.47 539.76 538.47 551.44 540.22 551.44"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="482.32 483.61 479.43 486.5 535.58 542.65 538.47 539.76 482.32 483.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="457.31"
					y1="539.76"
					x2="456.72"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.31"
					y1="551.44"
					x2="456.72"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.72"
					y1="539.76"
					x2="456.72"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.22"
					y1="539.76"
					x2="540.81"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.22"
					y1="551.44"
					x2="540.81"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.81"
					y1="539.76"
					x2="540.81"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.06"
					y1="551.44"
					x2="459.06"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.06"
					y1="539.76"
					x2="457.31"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.31"
					y1="539.76"
					x2="457.31"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="457.31"
					y1="551.44"
					x2="459.06"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.22"
					y1="551.44"
					x2="540.22"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.22"
					y1="539.76"
					x2="538.47"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.47"
					y1="539.76"
					x2="538.47"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.47"
					y1="551.44"
					x2="540.22"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.32"
					y1="483.61"
					x2="479.43"
					y2="486.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.43"
					y1="486.5"
					x2="535.58"
					y2="542.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.58"
					y1="542.65"
					x2="538.47"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.47"
					y1="539.76"
					x2="482.32"
					y2="483.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.72"
					y1="539.76"
					x2="456.72"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="539.76"
					x2="456.72"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="539.76"
					x2="453.22"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="539.76"
					x2="453.22"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="551.44"
					x2="453.22"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="456.72"
					y1="551.44"
					x2="453.22"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="539.76"
					x2="540.81"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="539.76"
					x2="540.81"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="539.76"
					x2="544.31"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="539.76"
					x2="544.31"
					y2="539.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="551.44"
					x2="544.31"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="540.81"
					y1="551.44"
					x2="544.31"
					y2="551.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="430.27"
					y1="659.84"
					x2="430.27"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="418.59"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="430.27"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="430.27"
					y1="575.76"
					x2="430.27"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="575.76"
					x2="418.59"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="575.76"
					x2="430.27"
					y2="575.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="418.59"
					y2="664.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="430.27"
					y1="664.48"
					x2="430.27"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="431.44 576.93 431.44 572.25 430.27 572.25 430.27 576.93 431.44 576.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="430.27 658.67 430.27 663.35 431.44 663.35 431.44 658.67 430.27 658.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="418.59 576.93 418.59 572.25 417.42 572.25 417.42 576.93 418.59 576.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.42 658.67 417.42 663.35 418.59 663.35 418.59 658.67 417.42 658.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="431.44"
					y1="576.93"
					x2="431.44"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.44"
					y1="572.25"
					x2="430.27"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="572.25"
					x2="430.27"
					y2="576.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="576.93"
					x2="431.44"
					y2="576.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="658.67"
					x2="430.27"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="663.35"
					x2="431.44"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.44"
					y1="663.35"
					x2="431.44"
					y2="658.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.44"
					y1="658.67"
					x2="430.27"
					y2="658.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="576.93"
					x2="418.59"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="572.25"
					x2="417.42"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.42"
					y1="572.25"
					x2="417.42"
					y2="576.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.42"
					y1="576.93"
					x2="418.59"
					y2="576.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.42"
					y1="658.67"
					x2="417.42"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.42"
					y1="663.35"
					x2="418.59"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="663.35"
					x2="418.59"
					y2="658.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="658.67"
					x2="417.42"
					y2="658.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="430.27 578.09 430.27 576.34 418.59 576.34 418.59 578.09 430.27 578.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="430.27 659.26 430.27 657.51 418.59 657.51 418.59 659.26 430.27 659.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="362.44 601.35 418.59 657.51 421.48 654.62 365.33 598.46 362.44 601.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="418.59"
					y1="576.34"
					x2="418.59"
					y2="575.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="576.34"
					x2="430.27"
					y2="575.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="575.76"
					x2="430.27"
					y2="575.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="659.26"
					x2="418.59"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="659.26"
					x2="430.27"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="430.27"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="578.09"
					x2="418.59"
					y2="578.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="578.09"
					x2="418.59"
					y2="576.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="576.34"
					x2="430.27"
					y2="576.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="576.34"
					x2="430.27"
					y2="578.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="659.26"
					x2="418.59"
					y2="659.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="659.26"
					x2="418.59"
					y2="657.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="657.51"
					x2="430.27"
					y2="657.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.27"
					y1="657.51"
					x2="430.27"
					y2="659.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.44"
					y1="601.35"
					x2="365.33"
					y2="598.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.33"
					y1="598.46"
					x2="421.48"
					y2="654.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.48"
					y1="654.62"
					x2="418.59"
					y2="657.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="657.51"
					x2="362.44"
					y2="601.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="418.59"
					y1="575.76"
					x2="430.27"
					y2="575.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="575.76"
					x2="430.27"
					y2="575.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="575.76"
					x2="418.59"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="575.76"
					x2="418.59"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="430.27"
					y1="575.76"
					x2="430.27"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="430.27"
					y1="575.76"
					x2="430.27"
					y2="572.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="430.27"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="430.27"
					y2="659.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="418.59"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="659.84"
					x2="418.59"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="430.27"
					y1="659.84"
					x2="430.27"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="430.27"
					y1="659.84"
					x2="430.27"
					y2="663.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="427.53"
					x2="416.69"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="425.2"
					x2="413.77"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="415.85"
					x2="416.69"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="415.85"
					x2="413.77"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="427.53"
					x2="267.21"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="425.2"
					x2="270.13"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="415.85"
					x2="267.21"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="415.85"
					x2="270.13"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="271.88 425.2 270.71 425.2 270.71 427.53 271.88 427.53 271.88 425.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="271.88 428.7 271.88 427.53 267.21 427.53 267.21 428.7 271.88 428.7"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="413.19 425.2 412.02 425.2 412.02 427.53 413.19 427.53 413.19 425.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="412.02 427.53 412.02 428.7 416.69 428.7 416.69 427.53 412.02 427.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="271.88 415.85 271.88 412.93 267.21 412.93 267.21 415.85 271.88 415.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="412.02 412.93 412.02 415.85 416.69 415.85 416.69 412.93 412.02 412.93"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="271.88"
					y1="425.2"
					x2="271.88"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.88"
					y1="427.53"
					x2="270.71"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.71"
					y1="427.53"
					x2="270.71"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.71"
					y1="425.2"
					x2="271.88"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.88"
					y1="428.7"
					x2="267.21"
					y2="428.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.21"
					y1="428.7"
					x2="267.21"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.21"
					y1="427.53"
					x2="271.88"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.88"
					y1="427.53"
					x2="271.88"
					y2="428.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.19"
					y1="425.2"
					x2="413.19"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.19"
					y1="427.53"
					x2="412.02"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.02"
					y1="427.53"
					x2="412.02"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.02"
					y1="425.2"
					x2="413.19"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.02"
					y1="427.53"
					x2="416.69"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.69"
					y1="427.53"
					x2="416.69"
					y2="428.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.69"
					y1="428.7"
					x2="412.02"
					y2="428.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.02"
					y1="428.7"
					x2="412.02"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.88"
					y1="415.85"
					x2="267.21"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.21"
					y1="415.85"
					x2="267.21"
					y2="412.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.21"
					y1="412.93"
					x2="271.88"
					y2="412.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.88"
					y1="412.93"
					x2="271.88"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.02"
					y1="412.93"
					x2="416.69"
					y2="412.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.69"
					y1="412.93"
					x2="416.69"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.69"
					y1="415.85"
					x2="412.02"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.02"
					y1="415.85"
					x2="412.02"
					y2="412.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="275.38 415.85 270.71 415.85 270.71 425.2 275.38 425.2 275.38 415.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="413.19 415.85 408.52 415.85 408.52 425.2 413.19 425.2 413.19 415.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="339.61 425.2 408.52 425.2 408.52 421.11 339.61 421.11 339.61 425.2"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="303.41 421.11 372.31 421.11 372.31 417.02 303.41 417.02 303.41 421.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="270.71"
					y1="425.2"
					x2="270.13"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.71"
					y1="415.85"
					x2="270.13"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.13"
					y1="425.2"
					x2="270.13"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.19"
					y1="425.2"
					x2="413.77"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.19"
					y1="415.85"
					x2="413.77"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.77"
					y1="425.2"
					x2="413.77"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.38"
					y1="415.85"
					x2="275.38"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="275.38"
					y1="425.2"
					x2="270.71"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.71"
					y1="425.2"
					x2="270.71"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.71"
					y1="415.85"
					x2="275.38"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.19"
					y1="415.85"
					x2="413.19"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="413.19"
					y1="425.2"
					x2="408.52"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.52"
					y1="425.2"
					x2="408.52"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.52"
					y1="415.85"
					x2="413.19"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.61"
					y1="425.2"
					x2="339.61"
					y2="421.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.61"
					y1="421.11"
					x2="408.52"
					y2="421.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.52"
					y1="421.11"
					x2="408.52"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="408.52"
					y1="425.2"
					x2="339.61"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.41"
					y1="421.11"
					x2="303.41"
					y2="417.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.41"
					y1="417.02"
					x2="372.31"
					y2="417.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.31"
					y1="417.02"
					x2="372.31"
					y2="421.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.31"
					y1="421.11"
					x2="303.41"
					y2="421.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.13"
					y1="415.85"
					x2="270.13"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="415.85"
					x2="270.13"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="425.2"
					x2="270.13"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="415.85"
					x2="267.21"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="425.2"
					x2="270.13"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="427.53"
					x2="267.21"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="270.13"
					y1="427.53"
					x2="267.21"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="415.85"
					x2="413.77"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="415.85"
					x2="413.77"
					y2="425.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="425.2"
					x2="413.77"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="415.85"
					x2="416.69"
					y2="415.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="425.2"
					x2="413.77"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="427.53"
					x2="416.69"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="413.77"
					y1="427.53"
					x2="416.69"
					y2="427.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="418.59"
					y1="483.99"
					x2="246.51"
					y2="483.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="273.95"
					y1="528.31"
					x2="262.28"
					y2="528.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="202.19"
					y1="528.31"
					x2="262.28"
					y2="528.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.59"
					y1="892.79"
					x2="562.59"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="564.93"
					y1="892.79"
					x2="562.59"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="892.79"
					x2="574.27"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="892.79"
					x2="564.93"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.59"
					y1="791.19"
					x2="562.59"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="564.93"
					y1="791.19"
					x2="562.59"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="791.19"
					x2="574.27"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="791.19"
					x2="564.93"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="564.93 792.94 564.93 791.77 562.59 791.77 562.59 792.94 564.93 792.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="561.42 792.94 562.59 792.94 562.59 788.27 561.42 788.27 561.42 792.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="564.93 892.21 564.93 891.04 562.59 891.04 562.59 892.21 564.93 892.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="562.59 891.04 561.42 891.04 561.42 895.71 562.59 895.71 562.59 891.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="574.27 792.94 577.19 792.94 577.19 788.27 574.27 788.27 574.27 792.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="577.19 891.04 574.27 891.04 574.27 895.71 577.19 895.71 577.19 891.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="564.93"
					y1="792.94"
					x2="562.59"
					y2="792.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="792.94"
					x2="562.59"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="791.77"
					x2="564.93"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="791.77"
					x2="564.93"
					y2="792.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.42"
					y1="792.94"
					x2="561.42"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.42"
					y1="788.27"
					x2="562.59"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="788.27"
					x2="562.59"
					y2="792.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="792.94"
					x2="561.42"
					y2="792.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="892.21"
					x2="562.59"
					y2="892.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="892.21"
					x2="562.59"
					y2="891.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="891.04"
					x2="564.93"
					y2="891.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="891.04"
					x2="564.93"
					y2="892.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="891.04"
					x2="562.59"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.59"
					y1="895.71"
					x2="561.42"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.42"
					y1="895.71"
					x2="561.42"
					y2="891.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.42"
					y1="891.04"
					x2="562.59"
					y2="891.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="792.94"
					x2="574.27"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="788.27"
					x2="577.19"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.19"
					y1="788.27"
					x2="577.19"
					y2="792.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.19"
					y1="792.94"
					x2="574.27"
					y2="792.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.19"
					y1="891.04"
					x2="577.19"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.19"
					y1="895.71"
					x2="574.27"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="895.71"
					x2="574.27"
					y2="891.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="891.04"
					x2="577.19"
					y2="891.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="574.27 796.45 574.27 791.77 564.93 791.77 564.93 796.45 574.27 796.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="574.27 892.21 574.27 887.54 564.93 887.54 564.93 892.21 574.27 892.21"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="564.93 839.65 564.93 887.54 569.02 887.54 569.02 839.65 564.93 839.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="569.02 824.47 569.02 872.35 573.1 872.35 573.1 824.47 569.02 824.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="564.93"
					y1="791.77"
					x2="564.93"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="791.77"
					x2="574.27"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="791.19"
					x2="574.27"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="892.21"
					x2="564.93"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="892.21"
					x2="574.27"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="892.79"
					x2="574.27"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="796.45"
					x2="564.93"
					y2="796.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="796.45"
					x2="564.93"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="791.77"
					x2="574.27"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="791.77"
					x2="574.27"
					y2="796.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="892.21"
					x2="564.93"
					y2="892.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="892.21"
					x2="564.93"
					y2="887.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="887.54"
					x2="574.27"
					y2="887.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="887.54"
					x2="574.27"
					y2="892.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="839.65"
					x2="569.02"
					y2="839.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.02"
					y1="839.65"
					x2="569.02"
					y2="887.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.02"
					y1="887.54"
					x2="564.93"
					y2="887.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.93"
					y1="887.54"
					x2="564.93"
					y2="839.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.02"
					y1="824.47"
					x2="573.1"
					y2="824.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.1"
					y1="824.47"
					x2="573.1"
					y2="872.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="573.1"
					y1="872.35"
					x2="569.02"
					y2="872.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="569.02"
					y1="872.35"
					x2="569.02"
					y2="824.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.27"
					y1="791.19"
					x2="564.93"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="791.19"
					x2="564.93"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="564.93"
					y1="791.19"
					x2="562.59"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="791.19"
					x2="574.27"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="564.93"
					y1="791.19"
					x2="562.59"
					y2="791.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.59"
					y1="791.19"
					x2="562.59"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.59"
					y1="791.19"
					x2="562.59"
					y2="788.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="892.79"
					x2="564.93"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="892.79"
					x2="564.93"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="564.93"
					y1="892.79"
					x2="562.59"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="574.27"
					y1="892.79"
					x2="574.27"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="564.93"
					y1="892.79"
					x2="562.59"
					y2="892.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.59"
					y1="892.79"
					x2="562.59"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<line
					x1="562.59"
					y1="892.79"
					x2="562.59"
					y2="895.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".33"
				/>
				<polyline
					points="369.55 570.01 373.72 571.87 378.24 572.51 382.76 571.87 386.93 570.01 389.67 567.65 391.76 564.69 394.4 557.73 395.34 551.96 394.99 546.13 393.37 540.5 393.51 535.36 394.81 530.39 397.21 525.85 398.47 523.87 399.94 519.81 399.72 515.5 399.06 513.8 399.06 509.26 397.16 509.26 397.16 511.33 394 509.41 390.37 508.67 366.11 508.67 362.53 509.4 359.45 511.39 357.31 514.35 356.39 517.88 356.39 518.44 356.87 521.36 359.33 525.95 361.72 530.45 363.01 535.36 363.14 540.45 361.5 546.09 361.15 551.94 362.08 557.73 364.72 564.69 366.81 567.65 369.55 570.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="386.89"
					y1="530.24"
					x2="369.59"
					y2="530.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.11"
					y1="508.67"
					x2="378.24"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.11"
					y1="509.54"
					x2="378.24"
					y2="509.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.37"
					y1="508.67"
					x2="378.24"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.37"
					y1="509.54"
					x2="378.24"
					y2="509.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.04"
					y1="530.24"
					x2="370.04"
					y2="527.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.04"
					y1="527.01"
					x2="372.72"
					y2="527.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.72"
					y1="527.01"
					x2="372.72"
					y2="530.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.44"
					y1="530.24"
					x2="386.44"
					y2="527.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.44"
					y1="527.01"
					x2="383.77"
					y2="527.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.77"
					y1="527.01"
					x2="383.77"
					y2="530.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="517.29"
					x2="397.16"
					y2="509.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.06"
					y1="517.29"
					x2="399.06"
					y2="509.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.06"
					y1="509.26"
					x2="397.16"
					y2="509.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.06"
					y1="517.29"
					x2="397.16"
					y2="517.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.24"
					y1="572.51"
					x2="375.34"
					y2="572.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.34"
					y1="572.18"
					x2="372.54"
					y2="571.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.54"
					y1="571.43"
					x2="369.55"
					y2="570.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.55"
					y1="570.01"
					x2="366.8"
					y2="567.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.8"
					y1="567.65"
					x2="364.72"
					y2="564.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.72"
					y1="564.69"
					x2="363.19"
					y2="561.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.19"
					y1="561.31"
					x2="362.08"
					y2="557.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.08"
					y1="557.73"
					x2="361.07"
					y2="551.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.07"
					y1="551.95"
					x2="361.02"
					y2="549.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.02"
					y1="549.04"
					x2="361.35"
					y2="546.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.35"
					y1="546.13"
					x2="362.66"
					y2="541.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.66"
					y1="541.62"
					x2="364.7"
					y2="537.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.7"
					y1="537.25"
					x2="367.13"
					y2="533.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.13"
					y1="533.36"
					x2="369.59"
					y2="530.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.14"
					y1="540.45"
					x2="363.11"
					y2="536.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.11"
					y1="536.4"
					x2="362.44"
					y2="532.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.44"
					y1="532.46"
					x2="361.76"
					y2="530.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.76"
					y1="530.34"
					x2="360.77"
					y2="528.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.77"
					y1="528.24"
					x2="358.82"
					y2="525.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.82"
					y1="525.18"
					x2="357.1"
					y2="522.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.1"
					y1="522.01"
					x2="356.41"
					y2="518.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.41"
					y1="518.92"
					x2="356.67"
					y2="515.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.67"
					y1="515.84"
					x2="357.87"
					y2="513.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.87"
					y1="513.04"
					x2="358.82"
					y2="511.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.82"
					y1="511.82"
					x2="359.99"
					y2="510.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.99"
					y1="510.78"
					x2="362.06"
					y2="509.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.06"
					y1="509.64"
					x2="364.04"
					y2="509"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.04"
					y1="509"
					x2="366.11"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.11"
					y1="509.54"
					x2="365.18"
					y2="509.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.18"
					y1="509.63"
					x2="363.28"
					y2="510.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.28"
					y1="510.23"
					x2="361.59"
					y2="511.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.59"
					y1="511.65"
					x2="360.54"
					y2="513.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.54"
					y1="513.62"
					x2="360.03"
					y2="516.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.03"
					y1="516.23"
					x2="359.92"
					y2="518.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.92"
					y1="518.91"
					x2="359.93"
					y2="520.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.93"
					y1="520.25"
					x2="360.5"
					y2="521.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.5"
					y1="521.3"
					x2="361.15"
					y2="521.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.15"
					y1="521.61"
					x2="368.49"
					y2="523.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.49"
					y1="523.7"
					x2="372.14"
					y2="524.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.14"
					y1="524.32"
					x2="375.83"
					y2="524.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.83"
					y1="524.58"
					x2="378.24"
					y2="524.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.37"
					y1="540.5"
					x2="393.4"
					y2="536.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.4"
					y1="536.44"
					x2="394.07"
					y2="532.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.07"
					y1="532.49"
					x2="394.74"
					y2="530.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.74"
					y1="530.35"
					x2="395.71"
					y2="528.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.71"
					y1="528.24"
					x2="397.66"
					y2="525.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.66"
					y1="525.17"
					x2="399.38"
					y2="522.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.38"
					y1="522.01"
					x2="399.95"
					y2="519.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.95"
					y1="519.95"
					x2="400.09"
					y2="517.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.09"
					y1="517.82"
					x2="399.79"
					y2="515.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="399.79"
					y1="515.74"
					x2="399.06"
					y2="513.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="390.37"
					y1="509.54"
					x2="391.3"
					y2="509.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.3"
					y1="509.63"
					x2="393.21"
					y2="510.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.21"
					y1="510.23"
					x2="394.89"
					y2="511.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.89"
					y1="511.65"
					x2="395.95"
					y2="513.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.95"
					y1="513.62"
					x2="396.45"
					y2="516.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.45"
					y1="516.23"
					x2="396.57"
					y2="518.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.57"
					y1="518.91"
					x2="396.55"
					y2="520.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.55"
					y1="520.25"
					x2="395.99"
					y2="521.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.99"
					y1="521.3"
					x2="395.33"
					y2="521.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.33"
					y1="521.61"
					x2="387.99"
					y2="523.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.99"
					y1="523.7"
					x2="384.34"
					y2="524.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.34"
					y1="524.32"
					x2="380.65"
					y2="524.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.65"
					y1="524.58"
					x2="378.24"
					y2="524.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.24"
					y1="572.51"
					x2="381.14"
					y2="572.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.14"
					y1="572.18"
					x2="383.94"
					y2="571.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.94"
					y1="571.43"
					x2="386.93"
					y2="570.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.93"
					y1="570.01"
					x2="389.68"
					y2="567.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.68"
					y1="567.65"
					x2="391.76"
					y2="564.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.76"
					y1="564.69"
					x2="393.29"
					y2="561.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.29"
					y1="561.31"
					x2="394.4"
					y2="557.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.4"
					y1="557.73"
					x2="395.41"
					y2="551.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.41"
					y1="551.95"
					x2="395.47"
					y2="549.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.47"
					y1="549.04"
					x2="395.14"
					y2="546.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.14"
					y1="546.13"
					x2="393.83"
					y2="541.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.83"
					y1="541.62"
					x2="391.78"
					y2="537.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.78"
					y1="537.25"
					x2="389.35"
					y2="533.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.35"
					y1="533.36"
					x2="386.89"
					y2="530.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="357.91"
					y1="523.69"
					x2="358.38"
					y2="524.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="358.38"
					y1="524.35"
					x2="359.71"
					y2="525.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.71"
					y1="525.34"
					x2="360.87"
					y2="525.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.87"
					y1="525.57"
					x2="368.32"
					y2="526.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.32"
					y1="526.2"
					x2="375.79"
					y2="526.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.79"
					y1="526.5"
					x2="378.24"
					y2="526.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.57"
					y1="523.69"
					x2="398.11"
					y2="524.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.11"
					y1="524.35"
					x2="396.77"
					y2="525.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.77"
					y1="525.34"
					x2="395.62"
					y2="525.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.62"
					y1="525.57"
					x2="388.16"
					y2="526.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="388.16"
					y1="526.2"
					x2="380.69"
					y2="526.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.69"
					y1="526.5"
					x2="378.24"
					y2="526.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="511.33"
					x2="396.49"
					y2="510.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.49"
					y1="510.78"
					x2="394.42"
					y2="509.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.42"
					y1="509.64"
					x2="392.44"
					y2="509"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.44"
					y1="509"
					x2="390.37"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="350.21 508.67 350.21 509.6 354.88 509.6 354.88 508.67 350.21 508.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.88"
					y1="508.67"
					x2="350.21"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.88"
					y1="509.6"
					x2="354.88"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.21"
					y1="509.6"
					x2="354.88"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.21"
					y1="508.67"
					x2="350.21"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="406.27 508.67 401.6 508.67 401.6 509.6 406.27 509.6 406.27 508.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="406.27"
					y1="509.6"
					x2="406.27"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.6"
					y1="509.6"
					x2="406.27"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="401.6"
					y1="508.67"
					x2="401.6"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.27"
					y1="508.67"
					x2="401.6"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="352.08 509.6 352.08 517.2 353.01 517.2 353.01 509.6 352.08 509.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.01"
					y1="509.6"
					x2="352.08"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.01"
					y1="517.2"
					x2="353.01"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.08"
					y1="517.2"
					x2="353.01"
					y2="517.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.08"
					y1="509.6"
					x2="352.08"
					y2="517.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="404.4 509.6 403.47 509.6 403.47 517.2 404.4 517.2 404.4 509.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="404.4"
					y1="517.2"
					x2="404.4"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.47"
					y1="517.2"
					x2="404.4"
					y2="517.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.47"
					y1="509.6"
					x2="403.47"
					y2="517.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="404.4"
					y1="509.6"
					x2="403.47"
					y2="509.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="353.01 514.87 353.01 516.74 403.47 516.74 403.47 514.87 353.01 514.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="403.47"
					y1="514.87"
					x2="353.01"
					y2="514.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.47"
					y1="516.74"
					x2="403.47"
					y2="514.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.01"
					y1="516.74"
					x2="403.47"
					y2="516.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.01"
					y1="514.87"
					x2="353.01"
					y2="516.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="273.95 528.31 202.19 528.31 202.19 664.48 273.95 664.48 273.95 528.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="273.95"
					y1="664.48"
					x2="273.95"
					y2="528.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.19"
					y1="664.48"
					x2="273.95"
					y2="664.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.19"
					y1="528.31"
					x2="202.19"
					y2="664.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.95"
					y1="528.31"
					x2="202.19"
					y2="528.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="265.46 536.84 211.63 536.84 211.63 655.37 265.46 655.37 265.46 536.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="265.46"
					y1="655.37"
					x2="265.46"
					y2="536.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.63"
					y1="655.37"
					x2="265.46"
					y2="655.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.63"
					y1="536.84"
					x2="211.63"
					y2="655.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.46"
					y1="536.84"
					x2="211.63"
					y2="536.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="238.07 548.49 238.55 548.45 239.02 548.33 239.46 548.14 239.86 547.88 240.2 547.56 240.48 547.19 240.69 546.78 240.81 546.34 240.85 545.89 240.81 545.43 240.69 545 240.48 544.59 240.2 544.21 239.86 543.89 239.46 543.63 239.02 543.44 238.55 543.32 238.07 543.29 237.59 543.32 237.12 543.44 236.68 543.63 236.28 543.89 235.94 544.21 235.66 544.59 235.46 545 235.33 545.43 235.29 545.89 235.33 546.34 235.46 546.78 235.66 547.19 235.94 547.56 236.28 547.88 236.68 548.14 237.12 548.33 237.59 548.45 238.07 548.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="237.59"
					y1="548.45"
					x2="238.07"
					y2="548.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.12"
					y1="548.33"
					x2="237.59"
					y2="548.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.68"
					y1="548.14"
					x2="237.12"
					y2="548.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.28"
					y1="547.88"
					x2="236.68"
					y2="548.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.94"
					y1="547.56"
					x2="236.28"
					y2="547.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.66"
					y1="547.19"
					x2="235.94"
					y2="547.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.46"
					y1="546.78"
					x2="235.66"
					y2="547.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.33"
					y1="546.34"
					x2="235.46"
					y2="546.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.29"
					y1="545.89"
					x2="235.33"
					y2="546.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.33"
					y1="545.43"
					x2="235.29"
					y2="545.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.46"
					y1="545"
					x2="235.33"
					y2="545.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.66"
					y1="544.59"
					x2="235.46"
					y2="545"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.94"
					y1="544.21"
					x2="235.66"
					y2="544.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.28"
					y1="543.89"
					x2="235.94"
					y2="544.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.68"
					y1="543.63"
					x2="236.28"
					y2="543.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.12"
					y1="543.44"
					x2="236.68"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="237.59"
					y1="543.32"
					x2="237.12"
					y2="543.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.07"
					y1="543.29"
					x2="237.59"
					y2="543.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.55"
					y1="543.32"
					x2="238.07"
					y2="543.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.02"
					y1="543.44"
					x2="238.55"
					y2="543.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.46"
					y1="543.63"
					x2="239.02"
					y2="543.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.86"
					y1="543.89"
					x2="239.46"
					y2="543.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.2"
					y1="544.21"
					x2="239.86"
					y2="543.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.48"
					y1="544.59"
					x2="240.2"
					y2="544.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.69"
					y1="545"
					x2="240.48"
					y2="544.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.81"
					y1="545.43"
					x2="240.69"
					y2="545"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.85"
					y1="545.89"
					x2="240.81"
					y2="545.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.81"
					y1="546.34"
					x2="240.85"
					y2="545.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.69"
					y1="546.78"
					x2="240.81"
					y2="546.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.48"
					y1="547.19"
					x2="240.69"
					y2="546.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.2"
					y1="547.56"
					x2="240.48"
					y2="547.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.86"
					y1="547.88"
					x2="240.2"
					y2="547.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.46"
					y1="548.14"
					x2="239.86"
					y2="547.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.02"
					y1="548.33"
					x2="239.46"
					y2="548.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.55"
					y1="548.45"
					x2="239.02"
					y2="548.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.07"
					y1="548.49"
					x2="238.55"
					y2="548.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="235.67 533.8 235.71 533.41 235.82 533.03 235.99 532.68 236.23 532.35 236.53 532.08 236.87 531.85 237.25 531.69 237.65 531.59 238.07 531.55 238.49 531.59 238.89 531.69 239.27 531.85 239.61 532.08 239.91 532.35 240.15 532.68 240.33 533.03 240.44 533.41 240.47 533.8 240.09 537.56 240.03 537.86 239.93 538.15 239.77 538.41 239.14 543.16 239.1 543.33 239.03 543.49 238.94 543.64 238.82 543.76 238.67 543.87 238.51 543.95 238.34 544.01 238.16 544.04 237.98 544.04 237.8 544.01 237.63 543.95 237.47 543.87 237.33 543.76 237.21 543.64 237.11 543.49 237.04 543.33 237.01 543.16 236.37 538.41 236.22 538.15 236.11 537.86 236.05 537.56 235.67 533.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="235.67"
					y1="533.8"
					x2="236.05"
					y2="537.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.37"
					y1="538.41"
					x2="237.01"
					y2="543.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.14"
					y1="543.16"
					x2="239.77"
					y2="538.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="240.09"
					y1="537.56"
					x2="240.47"
					y2="533.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.38"
					y1="536.03"
					x2="239.38"
					y2="537.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.76"
					y1="537.36"
					x2="236.76"
					y2="536.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.76"
					y1="536.03"
					x2="239.38"
					y2="536.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="730.08 684.39 783.38 684.39 783.38 632.01 730.08 632.01 730.08 684.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="730.08"
					y1="632.01"
					x2="730.08"
					y2="634.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="637.46"
					x2="730.08"
					y2="643.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="646.43"
					x2="730.08"
					y2="652.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="655.4"
					x2="730.08"
					y2="661"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="664.36"
					x2="730.08"
					y2="669.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="673.34"
					x2="730.08"
					y2="678.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="682.3"
					x2="730.08"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="632.01"
					x2="780.84"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="777.47"
					y1="632.01"
					x2="771.87"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="768.5"
					y1="632.01"
					x2="762.9"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.53"
					y1="632.01"
					x2="753.93"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="750.57"
					y1="632.01"
					x2="744.96"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.6"
					y1="632.01"
					x2="735.99"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="732.63"
					y1="632.01"
					x2="730.08"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="684.39"
					x2="783.38"
					y2="682.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="678.94"
					x2="783.38"
					y2="673.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="669.97"
					x2="783.38"
					y2="664.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="661"
					x2="783.38"
					y2="655.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="652.03"
					x2="783.38"
					y2="646.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="643.06"
					x2="783.38"
					y2="637.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="634.1"
					x2="783.38"
					y2="632.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="684.39"
					x2="732.63"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.99"
					y1="684.39"
					x2="741.6"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.96"
					y1="684.39"
					x2="750.57"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.93"
					y1="684.39"
					x2="759.53"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.9"
					y1="684.39"
					x2="768.5"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.87"
					y1="684.39"
					x2="777.47"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.84"
					y1="684.39"
					x2="783.38"
					y2="684.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="727.32 632.21 725.71 632.21 725.71 684.19 727.32 684.19 727.32 676.03 726.01 676.03 726.01 640.36 727.32 640.36 727.32 632.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="727.32"
					y1="640.36"
					x2="727.32"
					y2="632.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="726.01"
					y1="640.36"
					x2="727.32"
					y2="640.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="726.01"
					y1="676.03"
					x2="726.01"
					y2="640.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="727.32"
					y1="676.03"
					x2="726.01"
					y2="676.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="727.32"
					y1="684.19"
					x2="727.32"
					y2="676.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="725.71"
					y1="684.19"
					x2="727.32"
					y2="684.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="725.71"
					y1="632.21"
					x2="725.71"
					y2="684.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="727.32"
					y1="632.21"
					x2="725.71"
					y2="632.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="727.32 630.17 727.32 686.23 730.08 686.23 730.08 630.17 727.32 630.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="730.08"
					y1="630.17"
					x2="727.32"
					y2="630.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="730.08"
					y1="686.23"
					x2="730.08"
					y2="630.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="727.32"
					y1="686.23"
					x2="730.08"
					y2="686.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="727.32"
					y1="630.17"
					x2="727.32"
					y2="686.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="727.32"
					y1="684.19"
					x2="725.71"
					y2="684.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.71"
					y1="684.19"
					x2="725.71"
					y2="632.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.71"
					y1="632.21"
					x2="727.32"
					y2="632.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="686.23"
					x2="727.32"
					y2="630.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="640.36"
					x2="726.01"
					y2="640.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.01"
					y1="640.36"
					x2="726.01"
					y2="676.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="726.01"
					y1="676.03"
					x2="727.32"
					y2="676.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="686.23"
					x2="727.32"
					y2="686.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="630.17"
					x2="730.08"
					y2="630.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.08"
					y1="630.17"
					x2="730.08"
					y2="686.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="718.93 930.15 718.93 851.84 803.81 851.84 803.81 930.15 718.93 930.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="718.93"
					y1="930.15"
					x2="718.93"
					y2="851.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.93"
					y1="851.84"
					x2="803.81"
					y2="851.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.81"
					y1="851.84"
					x2="803.81"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.81"
					y1="930.15"
					x2="718.93"
					y2="930.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.78"
					y1="930.15"
					x2="724.78"
					y2="851.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="734.04 692.41 734.04 750.59 734.29 751.51 734.96 752.18 735.88 752.43 774.83 752.43 775.75 752.18 776.42 751.51 776.66 750.59 776.66 692.41 776.42 691.49 775.75 690.81 774.83 690.57 735.88 690.57 734.96 690.81 734.29 691.49 734.04 692.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="774.83"
					y1="690.57"
					x2="735.88"
					y2="690.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="776.66"
					y1="750.59"
					x2="776.66"
					y2="692.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.88"
					y1="752.43"
					x2="774.83"
					y2="752.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.04"
					y1="692.41"
					x2="734.04"
					y2="750.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.64"
					y1="697"
					x2="738.64"
					y2="745.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.48"
					y1="747.83"
					x2="765.63"
					y2="747.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="767.47"
					y1="745.99"
					x2="767.47"
					y2="697"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.63"
					y1="695.16"
					x2="740.48"
					y2="695.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.64"
					y1="697"
					x2="738.64"
					y2="697"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="755.71 720.67 755.12 720.91 754.88 721.5 755.13 722.08 755.71 722.32 773.91 722.32 774.49 722.08 774.73 721.5 774.49 720.91 773.91 720.67 755.71 720.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.91"
					y1="720.67"
					x2="755.71"
					y2="720.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.71"
					y1="722.32"
					x2="773.91"
					y2="722.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="769.22 719.66 769.22 720.67 773.91 720.67 774.49 720.91 774.73 721.5 774.49 722.08 773.91 722.32 769.22 722.32 769.22 723.33 775.19 723.33 775.19 719.66 769.22 719.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="775.19"
					y1="719.66"
					x2="769.22"
					y2="719.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="775.19"
					y1="723.33"
					x2="775.19"
					y2="719.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.22"
					y1="723.33"
					x2="775.19"
					y2="723.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.22"
					y1="722.32"
					x2="769.22"
					y2="723.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.91"
					y1="722.32"
					x2="769.22"
					y2="722.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.22"
					y1="720.67"
					x2="773.91"
					y2="720.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.22"
					y1="719.66"
					x2="769.22"
					y2="720.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="765.91 719.68 765.91 720.67 769.13 720.67 769.13 719.68 765.91 719.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="769.13"
					y1="719.68"
					x2="765.91"
					y2="719.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.13"
					y1="720.67"
					x2="769.13"
					y2="719.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.91"
					y1="720.67"
					x2="769.13"
					y2="720.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.91"
					y1="719.68"
					x2="765.91"
					y2="720.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="765.91 723.31 769.13 723.31 769.13 722.32 765.91 722.32 765.91 723.31"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="765.91"
					y1="722.32"
					x2="765.91"
					y2="723.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.13"
					y1="722.32"
					x2="765.91"
					y2="722.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.13"
					y1="723.31"
					x2="769.13"
					y2="722.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.91"
					y1="723.31"
					x2="769.13"
					y2="723.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="276.77 555.36 337.5 555.36 337.5 508.67 276.77 508.67 276.77 555.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="276.77"
					y1="555.36"
					x2="337.5"
					y2="555.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.77"
					y1="508.67"
					x2="337.5"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.5"
					y1="555.36"
					x2="337.5"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.77"
					y1="555.36"
					x2="276.77"
					y2="508.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.77"
					y1="510.51"
					x2="337.5"
					y2="510.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.77"
					y1="544.28"
					x2="330.49"
					y2="544.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.49"
					y1="544.28"
					x2="330.49"
					y2="516.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.49"
					y1="516.25"
					x2="283.77"
					y2="516.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.77"
					y1="516.25"
					x2="283.77"
					y2="544.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.94"
					y1="546.12"
					x2="332.33"
					y2="546.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.33"
					y1="546.12"
					x2="332.33"
					y2="514.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.33"
					y1="514.41"
					x2="281.94"
					y2="514.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.94"
					y1="514.41"
					x2="281.94"
					y2="546.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="304.83 511.19 305.2 515.05 305.5 515.93 306.11 520.79 306.45 521.44 307.13 521.69 307.81 521.44 308.15 520.79 308.76 515.93 309.06 515.05 309.43 511.19 308.99 509.84 307.84 509.01 306.42 509.01 305.27 509.84 304.83 511.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="309.06"
					y1="515.05"
					x2="309.43"
					y2="511.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.15"
					y1="520.79"
					x2="308.76"
					y2="515.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.5"
					y1="515.93"
					x2="306.11"
					y2="520.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.83"
					y1="511.19"
					x2="305.2"
					y2="515.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="308.38"
					y1="513.48"
					x2="308.38"
					y2="514.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.88"
					y1="514.85"
					x2="305.88"
					y2="513.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="305.88"
					y1="513.48"
					x2="308.38"
					y2="513.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.17"
					y1="717.8"
					x2="575.13"
					y2="717.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="575.13"
					y1="717.8"
					x2="575.13"
					y2="758.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.17"
					y1="709.26"
					x2="560.17"
					y2="766.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.7"
					y1="766.96"
					x2="521.7"
					y2="709.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.7"
					y1="709.26"
					x2="579.4"
					y2="709.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.4"
					y1="766.96"
					x2="521.7"
					y2="766.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.34"
					y1="709.26"
					x2="578.34"
					y2="766.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="560.17"
					y1="758.41"
					x2="575.13"
					y2="758.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.4"
					y1="709.26"
					x2="579.4"
					y2="766.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.93"
					y1="854.45"
					x2="713.78"
					y2="854.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.78"
					y1="854.45"
					x2="713.78"
					y2="857.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.78"
					y1="857.06"
					x2="718.93"
					y2="857.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="930.15"
					x2="727.32"
					y2="928.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="925.18"
					x2="727.32"
					y2="919.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="916.22"
					x2="727.32"
					y2="910.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="907.25"
					x2="727.32"
					y2="901.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="898.28"
					x2="727.32"
					y2="892.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="889.31"
					x2="727.32"
					y2="883.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="880.34"
					x2="727.32"
					y2="874.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="871.37"
					x2="727.32"
					y2="865.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="862.4"
					x2="727.32"
					y2="856.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="853.57"
					x2="727.32"
					y2="851.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="628.44"
					x2="727.32"
					y2="851.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.32"
					y1="628.44"
					x2="783.38"
					y2="628.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.11"
					y1="717.8"
					x2="528.11"
					y2="758.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.11"
					y1="758.41"
					x2="555.9"
					y2="758.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.9"
					y1="758.41"
					x2="555.9"
					y2="717.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="555.9"
					y1="717.8"
					x2="528.11"
					y2="717.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="433.07 54.49 395.25 54.49 395.25 59.55 433.07 59.55 433.07 54.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="393.42 54.03 434.91 54.03 434.91 54.49 393.42 54.49 393.42 54.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="393.42"
					y1="54.03"
					x2="434.91"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.91"
					y1="54.03"
					x2="434.91"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.91"
					y1="54.49"
					x2="393.42"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.42"
					y1="54.49"
					x2="393.42"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.07"
					y1="59.55"
					x2="395.25"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.25"
					y1="54.49"
					x2="433.07"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="437.21 59.55 433.07 59.55 433.07 54.49 437.21 54.49 437.21 59.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="437.21"
					y1="59.55"
					x2="433.07"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.07"
					y1="59.55"
					x2="433.07"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.07"
					y1="54.49"
					x2="437.21"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.21"
					y1="54.49"
					x2="437.21"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="391.12 54.49 395.25 54.49 395.25 59.55 391.12 59.55 391.12 54.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="391.12"
					y1="54.49"
					x2="395.25"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.25"
					y1="54.49"
					x2="395.25"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.25"
					y1="59.55"
					x2="391.12"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.12"
					y1="59.55"
					x2="391.12"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.07"
					y1="55.41"
					x2="395.25"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="439.05 59.09 437.21 59.09 437.21 54.49 434.91 54.49 434.91 54.03 439.05 54.03 439.05 59.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="439.05"
					y1="59.09"
					x2="437.21"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.21"
					y1="59.09"
					x2="437.21"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.21"
					y1="54.49"
					x2="434.91"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.91"
					y1="54.49"
					x2="434.91"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.91"
					y1="54.03"
					x2="439.05"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.05"
					y1="54.03"
					x2="439.05"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="389.28 54.03 393.42 54.03 393.42 54.49 391.12 54.49 391.12 59.09 389.28 59.09 389.28 54.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="389.28"
					y1="54.03"
					x2="393.42"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.42"
					y1="54.03"
					x2="393.42"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.42"
					y1="54.49"
					x2="391.12"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.12"
					y1="54.49"
					x2="391.12"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="391.12"
					y1="59.09"
					x2="389.28"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.28"
					y1="59.09"
					x2="389.28"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="386.94 55.41 386.94 57.74 291.3 57.74 291.3 55.41 386.94 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="386.94"
					y1="55.41"
					x2="386.94"
					y2="57.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.94"
					y1="57.74"
					x2="291.3"
					y2="57.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.3"
					y1="57.74"
					x2="291.3"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.3"
					y1="55.41"
					x2="386.94"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="439.05 55.41 443.72 55.41 443.72 69.42 439.05 69.42 439.05 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="443.72"
					y1="55.41"
					x2="439.05"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.72"
					y1="69.42"
					x2="443.72"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.05"
					y1="69.42"
					x2="443.72"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.05"
					y1="55.41"
					x2="439.05"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="384.6 55.41 389.28 55.41 389.28 69.42 384.6 69.42 384.6 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="389.28"
					y1="55.41"
					x2="384.6"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.28"
					y1="69.42"
					x2="389.28"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.6"
					y1="69.42"
					x2="389.28"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.6"
					y1="55.41"
					x2="384.6"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="288.96 55.41 293.63 55.41 293.63 69.42 288.96 69.42 288.96 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="293.63"
					y1="55.41"
					x2="288.96"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.63"
					y1="69.42"
					x2="293.63"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.96"
					y1="69.42"
					x2="293.63"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.96"
					y1="55.41"
					x2="288.96"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="719.53 54.49 680.1 54.49 680.1 59.55 719.53 59.55 719.53 54.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="678.26 54.03 721.37 54.03 721.37 54.49 678.26 54.49 678.26 54.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="678.26"
					y1="54.03"
					x2="721.37"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.37"
					y1="54.03"
					x2="721.37"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.37"
					y1="54.49"
					x2="678.26"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.26"
					y1="54.49"
					x2="678.26"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="59.55"
					x2="680.1"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.1"
					y1="54.49"
					x2="719.53"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="723.66 59.55 719.53 59.55 719.53 54.49 723.66 54.49 723.66 59.55"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="723.66"
					y1="59.55"
					x2="719.53"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="59.55"
					x2="719.53"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="54.49"
					x2="723.66"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.66"
					y1="54.49"
					x2="723.66"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="675.96 54.49 680.1 54.49 680.1 59.55 675.96 59.55 675.96 54.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="675.96"
					y1="54.49"
					x2="680.1"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.1"
					y1="54.49"
					x2="680.1"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="680.1"
					y1="59.55"
					x2="675.96"
					y2="59.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.96"
					y1="59.55"
					x2="675.96"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.53"
					y1="55.41"
					x2="680.1"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="725.5 59.09 723.66 59.09 723.66 54.49 721.37 54.49 721.37 54.03 725.5 54.03 725.5 59.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="725.5"
					y1="59.09"
					x2="723.66"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.66"
					y1="59.09"
					x2="723.66"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.66"
					y1="54.49"
					x2="721.37"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.37"
					y1="54.49"
					x2="721.37"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.37"
					y1="54.03"
					x2="725.5"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.5"
					y1="54.03"
					x2="725.5"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="674.12 54.03 678.26 54.03 678.26 54.49 675.96 54.49 675.96 59.09 674.12 59.09 674.12 54.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="674.12"
					y1="54.03"
					x2="678.26"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.26"
					y1="54.03"
					x2="678.26"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="678.26"
					y1="54.49"
					x2="675.96"
					y2="54.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.96"
					y1="54.49"
					x2="675.96"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.96"
					y1="59.09"
					x2="674.12"
					y2="59.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.12"
					y1="59.09"
					x2="674.12"
					y2="54.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="671.78 55.41 671.78 57.74 576.95 57.74 576.95 55.41 671.78 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="671.78"
					y1="55.41"
					x2="671.78"
					y2="57.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.78"
					y1="57.74"
					x2="576.95"
					y2="57.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.95"
					y1="57.74"
					x2="576.95"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="576.95"
					y1="55.41"
					x2="671.78"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="725.5 55.41 730.18 55.41 730.18 69.42 725.5 69.42 725.5 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="730.18"
					y1="55.41"
					x2="725.5"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.18"
					y1="69.42"
					x2="730.18"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.5"
					y1="69.42"
					x2="730.18"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.5"
					y1="55.41"
					x2="725.5"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="669.45 55.41 674.12 55.41 674.12 69.42 669.45 69.42 669.45 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="674.12"
					y1="55.41"
					x2="669.45"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.12"
					y1="69.42"
					x2="674.12"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.45"
					y1="69.42"
					x2="674.12"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.45"
					y1="55.41"
					x2="669.45"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="574.61 55.41 579.28 55.41 579.28 69.42 574.61 69.42 574.61 55.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="579.28"
					y1="55.41"
					x2="574.61"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="579.28"
					y1="69.42"
					x2="579.28"
					y2="55.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.61"
					y1="69.42"
					x2="579.28"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="574.61"
					y1="55.41"
					x2="574.61"
					y2="69.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="722.65 756.77 722.65 826.84 783.38 826.84 783.38 756.77 722.65 756.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="722.65"
					y1="756.77"
					x2="722.65"
					y2="826.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.38"
					y1="756.77"
					x2="783.38"
					y2="826.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.54"
					y1="756.77"
					x2="781.54"
					y2="826.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.65"
					y1="756.77"
					x2="783.38"
					y2="756.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.65"
					y1="826.84"
					x2="783.38"
					y2="826.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.41"
					y1="761.36"
					x2="725.41"
					y2="822.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.41"
					y1="822.24"
					x2="727.25"
					y2="824.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.25"
					y1="824.08"
					x2="778.78"
					y2="824.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.78"
					y1="824.08"
					x2="780.62"
					y2="822.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.62"
					y1="822.24"
					x2="780.62"
					y2="761.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="780.62"
					y1="761.36"
					x2="778.78"
					y2="759.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.78"
					y1="759.52"
					x2="727.25"
					y2="759.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.25"
					y1="759.52"
					x2="725.41"
					y2="761.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="628.44"
					x2="755.35"
					y2="630.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="634.19"
					x2="755.35"
					y2="639.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="643.16"
					x2="755.35"
					y2="648.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="652.13"
					x2="755.35"
					y2="657.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="661.1"
					x2="755.35"
					y2="666.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="670.07"
					x2="755.35"
					y2="675.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="679.03"
					x2="755.35"
					y2="684.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="688.01"
					x2="755.35"
					y2="693.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="696.97"
					x2="755.35"
					y2="702.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="705.94"
					x2="755.35"
					y2="711.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="714.91"
					x2="755.35"
					y2="720.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="723.88"
					x2="755.35"
					y2="729.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="732.85"
					x2="755.35"
					y2="738.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="741.82"
					x2="755.35"
					y2="747.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="750.79"
					x2="755.35"
					y2="756.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="759.76"
					x2="755.35"
					y2="765.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="768.73"
					x2="755.35"
					y2="774.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="777.7"
					x2="755.35"
					y2="783.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="786.66"
					x2="755.35"
					y2="792.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="795.63"
					x2="755.35"
					y2="801.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="804.6"
					x2="755.35"
					y2="810.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="813.57"
					x2="755.35"
					y2="819.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="822.54"
					x2="755.35"
					y2="828.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="831.51"
					x2="755.35"
					y2="837.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="840.48"
					x2="755.35"
					y2="846.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.35"
					y1="849.45"
					x2="755.35"
					y2="851.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="822.45 50 822.45 947.96 670.75 947.96 670.75 929.28 803.77 929.28 803.77 850.98 783.34 850.98 783.34 550.64 646.77 550.64 646.77 538.96 803.77 538.96 803.77 68.68 730.14 68.68 730.14 50 822.45 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.58"
				/>
				<polygon
					points="583.85 707.03 583.85 701.47 508.92 701.47 508.92 773.3 583.85 773.3 583.85 767.74 595.53 767.74 595.53 784.98 574.26 784.98 574.26 790.35 562.59 790.35 562.59 784.98 508.92 784.98 508.92 896.63 562.59 896.63 562.59 891.93 574.26 891.93 574.26 929.28 582.01 929.28 582.01 947.96 490.24 947.96 490.24 682.34 183.55 682.34 183.55 50 289 50 289 68.68 202.23 68.68 202.23 415.07 270.16 415.07 270.16 426.74 246.55 426.74 246.55 483.2 418.6 483.2 418.6 426.74 413.79 426.74 413.79 415.07 430.28 415.07 430.28 538.96 456.73 538.96 456.73 550.64 430.28 550.64 430.28 574.95 418.6 574.95 418.6 507.87 273.99 507.87 273.99 527.5 202.23 527.5 202.23 663.66 418.6 663.66 418.6 659.02 430.28 659.02 430.28 663.66 595.53 663.66 595.53 707.03 583.85 707.03"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.58"
				/>
				<polygon
					points="574.6 50 574.6 68.68 564.39 68.68 564.39 144.08 557.55 144.08 557.55 538.96 562.69 538.96 562.69 550.64 540.8 550.64 540.8 538.96 545.88 538.96 545.88 186.58 489 186.58 489 111.32 468.03 111.32 468.03 68.68 443.73 68.68 443.73 50 574.6 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.58"
				/>
			</g>
			<g id="text">
				<path d="m754.5,654.44c-.33-.88-.82-1.6-1.49-2.16-.51-.44-1.13-.74-1.85-.9-.52-.12-1.27-.18-2.25-.18h-4.35v12.62h4.55c.76,0,1.44-.07,2.02-.22.59-.14,1.09-.35,1.51-.63.42-.28.8-.66,1.15-1.14.35-.49.64-1.1.86-1.84.22-.74.34-1.59.34-2.55,0-1.12-.17-2.12-.5-2.99Zm-1.56,5.4c-.22.67-.52,1.2-.92,1.59-.28.28-.66.5-1.14.65-.47.16-1.12.23-1.95.23h-2.69v-9.64h2.65c.99,0,1.71.09,2.16.26.62.24,1.14.72,1.57,1.43.44.71.65,1.72.65,3.04,0,.95-.11,1.76-.34,2.44Z" />
				<path d="m772.37,651.2l-3.46,12.62h-1.61l-2.66-9.61c-.22-.8-.36-1.3-.4-1.48-.13.58-.26,1.07-.37,1.48l-2.68,9.61h-1.7l-3.35-12.62h1.71l1.92,8.27c.21.87.38,1.73.53,2.58.32-1.35.51-2.13.57-2.33l2.4-8.52h2.01l1.81,6.39c.45,1.58.78,3.07.98,4.47.16-.8.37-1.71.63-2.75l1.98-8.11" />
				<path d="m765.81,899.35h-1.77l-2.12-3.56c-.19-.33-.38-.61-.57-.84-.18-.24-.37-.43-.57-.58-.19-.15-.4-.25-.62-.32-.22-.07-.47-.11-.74-.11h-1.22v5.4h-1.49v-12.69h3.79c.55,0,1.07.07,1.53.21.47.14.88.35,1.22.63.35.28.62.64.81,1.06.19.42.29.91.29,1.48,0,.44-.07.85-.2,1.22-.13.37-.32.69-.57.98-.24.29-.54.54-.89.74-.34.2-.73.36-1.16.47v.04c.21.09.4.2.55.33.16.12.31.26.45.42.14.17.28.35.42.57.14.21.3.45.47.73l2.38,3.81Zm-7.61-11.35v4.6h2.02c.37,0,.71-.06,1.03-.17.32-.11.59-.27.82-.48.23-.21.41-.47.54-.77.13-.31.19-.65.19-1.03,0-.68-.22-1.21-.66-1.58-.44-.38-1.07-.58-1.9-.58h-2.04Zm16.28,7.18h-6.4c.02,1.01.3,1.79.81,2.34.52.55,1.23.82,2.14.82,1.02,0,1.96-.34,2.81-1.01v1.36c-.8.58-1.85.87-3.16.87s-2.29-.41-3.02-1.23c-.73-.83-1.1-1.99-1.1-3.48,0-1.41.4-2.56,1.19-3.44.8-.89,1.8-1.34,2.98-1.34s2.1.38,2.75,1.15c.65.77.97,1.83.97,3.2v.76Zm-1.49-1.23c0-.84-.21-1.49-.61-1.96-.4-.47-.95-.7-1.66-.7s-1.27.24-1.74.73c-.48.49-.77,1.13-.89,1.92h4.89Zm8-6.74c-.28-.16-.6-.24-.96-.24-1.01,0-1.52.64-1.52,1.92v1.4h2.12v1.24h-2.12v7.82h-1.44v-7.82h-1.55v-1.24h1.55v-1.47c0-.95.27-1.7.82-2.25.55-.55,1.23-.83,2.05-.83.44,0,.79.05,1.05.16v1.31Z" />
				<path d="m782.53,899.55c-.27,0-.5-.1-.7-.29-.19-.19-.28-.43-.28-.7s.09-.5.28-.7c.19-.2.43-.3.7-.3s.51.1.71.3c.19.19.29.43.29.7s-.1.5-.29.7c-.19.19-.43.29-.71.29Z" />
				<path d="m311.02,613.18v-19.71h5.61c1.7,0,3.06.42,4.05,1.25,1,.83,1.5,1.92,1.5,3.26,0,1.12-.3,2.09-.91,2.91-.6.82-1.44,1.41-2.5,1.76v.06c1.33.16,2.39.66,3.19,1.51.8.84,1.2,1.94,1.2,3.3,0,1.69-.6,3.05-1.81,4.1-1.21,1.04-2.74,1.57-4.58,1.57h-5.75Zm2.31-17.62v6.36h2.36c1.26,0,2.26-.3,2.98-.91.72-.61,1.09-1.48,1.09-2.58,0-1.92-1.26-2.87-3.78-2.87h-2.65Zm0,8.44v7.09h3.13c1.36,0,2.41-.32,3.15-.96.75-.64,1.13-1.52,1.13-2.64,0-2.33-1.59-3.49-4.76-3.49h-2.65Zm23.59,9.18h-2.25v-2.2h-.05c-.98,1.69-2.42,2.53-4.33,2.53-1.4,0-2.5-.37-3.3-1.11-.79-.74-1.18-1.73-1.18-2.96,0-2.63,1.55-4.16,4.65-4.59l4.22-.59c0-2.39-.97-3.59-2.9-3.59-1.7,0-3.23.58-4.59,1.73v-2.31c1.38-.88,2.98-1.32,4.78-1.32,3.31,0,4.96,1.75,4.96,5.25v9.15Zm-2.25-7.12l-3.4.47c-1.04.15-1.83.41-2.36.78-.53.37-.8,1.02-.8,1.97,0,.69.24,1.25.73,1.69.49.43,1.15.65,1.97.65,1.12,0,2.04-.39,2.76-1.17.73-.79,1.1-1.78,1.1-2.98v-1.4Zm13.03,6.98c-.53.29-1.23.44-2.1.44-2.46,0-3.7-1.37-3.7-4.12v-8.33h-2.42v-1.92h2.42v-3.44l2.25-.73v4.16h3.55v1.92h-3.55v7.93c0,.94.16,1.62.48,2.02.32.4.85.6,1.59.6.57,0,1.06-.16,1.47-.47v1.92Zm14.69.14h-2.25v-8.11c0-2.93-1.09-4.4-3.27-4.4-1.1,0-2.03.43-2.78,1.28-.75.84-1.13,1.93-1.13,3.26v7.97h-2.25v-20.84h2.25v9.1h.06c1.08-1.78,2.62-2.67,4.62-2.67,3.17,0,4.76,1.91,4.76,5.73v8.67Z" />
				<path d="m608.56,910.89h-10.45v-19.71h10.01v2.09h-7.7v6.56h7.12v2.08h-7.12v6.9h8.14v2.09Zm15.2,0h-2.25v-8.03c0-2.99-1.09-4.48-3.27-4.48-1.13,0-2.06.43-2.8,1.28-.73.84-1.1,1.91-1.1,3.2v8.03h-2.25v-14.08h2.25v2.34h.05c1.06-1.78,2.6-2.67,4.62-2.67,1.54,0,2.72.5,3.53,1.5.82.99,1.22,2.42,1.22,4.3v8.6Zm10.8-.14c-.53.29-1.23.44-2.1.44-2.47,0-3.7-1.37-3.7-4.12v-8.33h-2.42v-1.92h2.42v-3.44l2.25-.73v4.16h3.55v1.92h-3.55v7.93c0,.94.16,1.62.48,2.02.32.4.85.6,1.59.6.57,0,1.06-.16,1.47-.47v1.92Zm10.37-11.66c-.39-.3-.96-.45-1.7-.45-.96,0-1.77.45-2.42,1.36-.64.91-.96,2.14-.96,3.71v7.18h-2.25v-14.08h2.25v2.9h.05c.32-.99.81-1.76,1.47-2.31.66-.56,1.4-.84,2.21-.84.59,0,1.04.06,1.35.19v2.34Zm13.68-2.28l-6.47,16.33c-1.15,2.91-2.78,4.37-4.87,4.37-.59,0-1.08-.06-1.47-.18v-2.02c.49.16.93.25,1.33.25,1.14,0,1.99-.68,2.56-2.03l1.13-2.67-5.5-14.05h2.5l3.81,10.83c.05.14.14.49.29,1.07h.08c.05-.22.14-.57.27-1.04l4-10.86h2.34Z" />
				<path d="m332.22,247.3v-19.71h5.61c1.7,0,3.06.42,4.05,1.25,1,.83,1.5,1.92,1.5,3.26,0,1.12-.3,2.09-.91,2.91-.6.82-1.44,1.41-2.5,1.76v.05c1.33.16,2.39.66,3.19,1.51.8.84,1.2,1.94,1.2,3.3,0,1.69-.6,3.05-1.81,4.1-1.21,1.04-2.74,1.57-4.58,1.57h-5.75Zm2.31-17.62v6.36h2.36c1.26,0,2.26-.3,2.98-.91.72-.61,1.09-1.48,1.09-2.58,0-1.92-1.26-2.87-3.78-2.87h-2.65Zm0,8.44v7.09h3.13c1.36,0,2.41-.32,3.15-.96.75-.64,1.13-1.52,1.13-2.64,0-2.33-1.59-3.49-4.76-3.49h-2.65Zm24.81,2.71h-9.94c.04,1.57.46,2.78,1.26,3.63.81.85,1.92,1.28,3.33,1.28,1.59,0,3.04-.52,4.37-1.57v2.12c-1.24.9-2.87,1.35-4.91,1.35s-3.55-.64-4.69-1.91c-1.14-1.28-1.7-3.08-1.7-5.4,0-2.19.62-3.97,1.86-5.35,1.25-1.38,2.79-2.08,4.63-2.08s3.27.6,4.27,1.79c1.01,1.19,1.51,2.85,1.51,4.96v1.18Zm-2.31-1.91c0-1.3-.33-2.31-.95-3.04-.61-.72-1.47-1.09-2.57-1.09s-1.97.38-2.71,1.14c-.74.76-1.2,1.75-1.37,2.98h7.6Zm17.71,8.38h-2.25v-2.39h-.05c-1.04,1.81-2.66,2.72-4.84,2.72-1.77,0-3.18-.63-4.25-1.88-1.05-1.26-1.58-2.98-1.58-5.15,0-2.33.59-4.19,1.76-5.59,1.17-1.4,2.74-2.1,4.69-2.1s3.34.76,4.22,2.28h.05v-8.71h2.25v20.84Zm-2.25-6.36v-2.08c0-1.14-.38-2.1-1.13-2.89-.75-.79-1.7-1.18-2.86-1.18-1.37,0-2.46.5-3.24,1.51-.79,1.01-1.18,2.4-1.18,4.18,0,1.62.38,2.9,1.13,3.85.76.93,1.78,1.4,3.05,1.4s2.27-.45,3.05-1.36c.79-.91,1.18-2.05,1.18-3.44Zm14.14-5.43c-.39-.3-.96-.45-1.7-.45-.96,0-1.77.45-2.42,1.36-.64.91-.96,2.14-.96,3.71v7.18h-2.25v-14.08h2.25v2.9h.05c.32-.99.81-1.76,1.47-2.31.66-.56,1.4-.84,2.21-.84.59,0,1.04.06,1.35.19v2.34Zm8.31,12.12c-2.08,0-3.74-.66-4.99-1.97-1.24-1.32-1.86-3.07-1.86-5.24,0-2.36.65-4.21,1.94-5.54,1.29-1.33,3.04-1.99,5.24-1.99s3.73.65,4.91,1.94c1.18,1.29,1.77,3.08,1.77,5.37s-.64,4.05-1.91,5.4c-1.26,1.35-2.96,2.02-5.1,2.02Zm.16-12.84c-1.45,0-2.59.49-3.44,1.48-.84.98-1.26,2.34-1.26,4.07s.43,2.98,1.28,3.94c.85.96,1.99,1.44,3.42,1.44s2.58-.47,3.35-1.42c.79-.94,1.18-2.29,1.18-4.03s-.39-3.12-1.18-4.07c-.78-.95-1.9-1.43-3.35-1.43Zm16.31,12.84c-2.08,0-3.74-.66-4.99-1.97-1.24-1.32-1.86-3.07-1.86-5.24,0-2.36.65-4.21,1.94-5.54,1.29-1.33,3.04-1.99,5.24-1.99s3.73.65,4.91,1.94c1.18,1.29,1.77,3.08,1.77,5.37s-.64,4.05-1.91,5.4c-1.26,1.35-2.96,2.02-5.1,2.02Zm.16-12.84c-1.45,0-2.59.49-3.44,1.48-.84.98-1.26,2.34-1.26,4.07s.43,2.98,1.28,3.94c.85.96,1.99,1.44,3.42,1.44s2.57-.47,3.35-1.42c.79-.94,1.18-2.29,1.18-4.03s-.39-3.12-1.18-4.07c-.78-.95-1.9-1.43-3.35-1.43Zm30.41,12.51h-2.25v-8.08c0-1.56-.24-2.68-.73-3.38-.48-.7-1.28-1.04-2.42-1.04-.96,0-1.78.44-2.46,1.32-.67.88-1,1.93-1,3.16v8.03h-2.25v-8.36c0-2.77-1.07-4.15-3.2-4.15-.99,0-1.81.42-2.45,1.25-.64.82-.96,1.9-.96,3.23v8.03h-2.25v-14.08h2.25v2.23h.06c1-1.7,2.46-2.56,4.37-2.56.96,0,1.8.27,2.52.81.71.53,1.2,1.23,1.47,2.1,1.04-1.94,2.6-2.91,4.67-2.91,3.1,0,4.65,1.91,4.65,5.73v8.67Z" />
				<path d="m337.85,276.51h-1.64v-12.38c-.13.13-.31.27-.56.44-.24.16-.51.32-.82.48-.3.16-.62.31-.96.45-.33.14-.66.25-.98.33v-1.66c.36-.1.74-.23,1.14-.4.41-.17.8-.36,1.19-.57.39-.21.76-.43,1.11-.66.35-.23.65-.46.9-.68h.62v14.65Zm11.53-10.57c0-.44-.07-.82-.21-1.15-.13-.33-.32-.6-.56-.81-.23-.22-.51-.38-.83-.49-.32-.11-.67-.16-1.04-.16-.32,0-.63.04-.94.13-.31.09-.61.21-.9.36-.29.15-.57.34-.84.55-.27.21-.52.45-.75.71v-1.76c.46-.45.97-.79,1.54-1.02.57-.24,1.27-.36,2.09-.36.59,0,1.13.09,1.63.26.5.17.93.41,1.3.74.37.33.65.73.86,1.21.21.48.32,1.03.32,1.65,0,.57-.07,1.08-.2,1.54-.13.46-.32.89-.59,1.3-.26.41-.59.8-.99,1.17-.4.37-.87.75-1.41,1.14-.67.48-1.23.89-1.67,1.23-.43.34-.78.66-1.04.96-.25.29-.43.59-.54.89-.1.29-.15.63-.15,1.02h7.13v1.47h-8.84v-.71c0-.61.07-1.15.2-1.62.13-.47.35-.91.66-1.33.31-.42.71-.84,1.2-1.26.5-.42,1.11-.89,1.83-1.42.52-.37.95-.73,1.3-1.07.35-.34.64-.68.85-1.02.21-.34.36-.68.45-1.03.09-.35.14-.73.14-1.12Z" />
				<rect x="354.36" y="262.18" width="1.45" height="4.47" />
				<path d="m365.86,262.18v9.46h1.84v1.5h-1.84v3.37h-1.62v-3.37h-6.74v-1.42c.63-.71,1.26-1.46,1.9-2.26.64-.81,1.25-1.62,1.83-2.45.59-.83,1.13-1.65,1.62-2.47.5-.83.92-1.62,1.26-2.37h1.75Zm-6.51,9.46h4.89v-7.02c-.5.87-.97,1.65-1.42,2.34-.45.69-.87,1.31-1.28,1.87-.4.56-.78,1.07-1.15,1.52s-.71.88-1.04,1.29Z" />
				<path d="m371.5,262.18v4.47h-1.45v-4.47h1.45Zm3.32,0v4.47h-1.45v-4.47h1.45Z" />
				<path d="m391.2,266.28l-3.44,5.18,3.38,5.06h-1.91l-2.01-3.32c-.13-.21-.28-.47-.45-.78h-.04c-.03.06-.19.32-.47.78l-2.05,3.32h-1.89l3.49-5.02-3.34-5.22h1.91l1.98,3.5c.15.26.29.53.43.8h.04l2.56-4.3h1.81Z" />
				<path d="m404.32,276.51h-1.64v-12.38c-.13.13-.31.27-.56.44-.24.16-.51.32-.82.48-.3.16-.62.31-.96.45-.33.14-.66.25-.98.33v-1.66c.36-.1.74-.23,1.14-.4.41-.17.8-.36,1.19-.57.39-.21.76-.43,1.11-.66.35-.23.65-.46.9-.68h.62v14.65Zm11.53-10.57c0-.44-.07-.82-.21-1.15-.13-.33-.32-.6-.56-.81-.23-.22-.51-.38-.83-.49-.32-.11-.67-.16-1.04-.16-.32,0-.63.04-.94.13-.31.09-.61.21-.9.36-.29.15-.57.34-.84.55-.27.21-.52.45-.75.71v-1.76c.46-.45.97-.79,1.54-1.02.57-.24,1.27-.36,2.09-.36.59,0,1.13.09,1.63.26.5.17.93.41,1.3.74.37.33.65.73.86,1.21.21.48.32,1.03.32,1.65,0,.57-.07,1.08-.2,1.54-.13.46-.32.89-.59,1.3-.26.41-.59.8-.99,1.17-.4.37-.87.75-1.41,1.14-.67.48-1.23.89-1.67,1.23-.43.34-.78.66-1.04.96-.25.29-.43.59-.54.89-.1.29-.15.63-.15,1.02h7.14v1.47h-8.84v-.71c0-.61.07-1.15.2-1.62.13-.47.35-.91.66-1.33.31-.42.71-.84,1.2-1.26.5-.42,1.11-.89,1.83-1.42.52-.37.95-.73,1.3-1.07.35-.34.64-.68.85-1.02.21-.34.36-.68.45-1.03.09-.35.14-.73.14-1.12Z" />
				<rect x="420.82" y="262.18" width="1.45" height="4.47" />
				<path d="m432.33,262.18v9.46h1.84v1.5h-1.84v3.37h-1.62v-3.37h-6.74v-1.42c.63-.71,1.26-1.46,1.9-2.26.64-.81,1.25-1.62,1.83-2.45.59-.83,1.13-1.65,1.62-2.47.5-.83.92-1.62,1.26-2.37h1.75Zm-6.51,9.46h4.89v-7.02c-.5.87-.97,1.65-1.42,2.34-.45.69-.87,1.31-1.28,1.87-.4.56-.78,1.07-1.15,1.52-.37.45-.71.88-1.04,1.29Z" />
				<path d="m437.96,262.18v4.47h-1.45v-4.47h1.45Zm3.32,0v4.47h-1.45v-4.47h1.45Z" />
				<path d="m630.88,689.56h-3.22l-7.61-9.02c-.28-.34-.46-.57-.52-.69h-.05v9.7h-2.31v-19.71h2.31v9.26h.05c.13-.2.3-.43.52-.67l7.37-8.59h2.87l-8.45,9.46,9.04,10.25Zm3.44-17.65c-.4,0-.75-.14-1.03-.41-.28-.27-.43-.62-.43-1.04s.14-.77.43-1.04c.28-.28.63-.43,1.03-.43s.76.14,1.04.43c.29.27.44.62.44,1.04s-.15.75-.44,1.03c-.28.28-.63.43-1.04.43Zm1.1,17.65h-2.25v-14.08h2.25v14.08Zm11.07-.14c-.53.29-1.23.44-2.1.44-2.47,0-3.7-1.37-3.7-4.12v-8.33h-2.42v-1.92h2.42v-3.44l2.25-.73v4.16h3.55v1.92h-3.55v7.93c0,.94.16,1.62.48,2.02.32.4.85.6,1.59.6.57,0,1.06-.16,1.47-.47v1.92Zm12.59-.51c-1.08.65-2.36.98-3.85.98-2.01,0-3.63-.65-4.87-1.95-1.23-1.31-1.84-3.01-1.84-5.09,0-2.32.66-4.18,1.99-5.58,1.33-1.41,3.1-2.12,5.32-2.12,1.24,0,2.33.23,3.27.69v2.31c-1.04-.73-2.16-1.1-3.35-1.1-1.44,0-2.62.52-3.55,1.55-.92,1.03-1.37,2.38-1.37,4.05s.43,2.95,1.29,3.9c.87.95,2.03,1.43,3.49,1.43,1.23,0,2.38-.41,3.46-1.22v2.14Zm15.08.65h-2.25v-8.11c0-2.93-1.09-4.4-3.27-4.4-1.1,0-2.03.43-2.78,1.28-.75.84-1.13,1.93-1.13,3.26v7.97h-2.25v-20.84h2.25v9.1h.05c1.08-1.78,2.62-2.67,4.62-2.67,3.17,0,4.76,1.91,4.76,5.73v8.67Zm15.54-6.47h-9.94c.04,1.57.46,2.78,1.26,3.63.81.85,1.92,1.28,3.33,1.28,1.59,0,3.04-.52,4.37-1.57v2.12c-1.24.9-2.87,1.35-4.91,1.35s-3.55-.64-4.69-1.91c-1.14-1.28-1.7-3.08-1.7-5.4,0-2.19.62-3.97,1.86-5.35,1.25-1.38,2.79-2.08,4.63-2.08s3.27.6,4.27,1.79c1.01,1.19,1.51,2.85,1.51,4.96v1.18Zm-2.31-1.91c0-1.3-.33-2.31-.95-3.04-.61-.72-1.47-1.09-2.57-1.09s-1.97.38-2.71,1.14c-.74.76-1.2,1.75-1.37,2.98h7.6Zm17.38,8.38h-2.25v-8.03c0-2.99-1.09-4.48-3.27-4.48-1.13,0-2.06.43-2.8,1.28-.73.84-1.1,1.91-1.1,3.2v8.03h-2.25v-14.08h2.25v2.34h.05c1.06-1.78,2.6-2.67,4.62-2.67,1.54,0,2.72.5,3.53,1.5.82.99,1.22,2.42,1.22,4.3v8.6Z" />
				<path d="m642.9,299.46v-19.71h5.61c1.7,0,3.06.42,4.05,1.25,1,.83,1.5,1.92,1.5,3.26,0,1.12-.3,2.09-.91,2.91-.6.82-1.44,1.41-2.5,1.76v.05c1.33.16,2.39.66,3.19,1.51.8.84,1.2,1.94,1.2,3.3,0,1.69-.6,3.05-1.81,4.1-1.21,1.04-2.74,1.57-4.58,1.57h-5.75Zm2.31-17.62v6.36h2.36c1.26,0,2.26-.3,2.98-.91.72-.61,1.09-1.48,1.09-2.58,0-1.92-1.26-2.87-3.78-2.87h-2.65Zm0,8.44v7.09h3.13c1.36,0,2.41-.32,3.15-.96.75-.64,1.13-1.52,1.13-2.64,0-2.33-1.59-3.49-4.76-3.49h-2.65Zm24.81,2.71h-9.94c.04,1.57.46,2.78,1.26,3.63.81.85,1.92,1.28,3.33,1.28,1.59,0,3.04-.52,4.37-1.57v2.12c-1.24.9-2.87,1.35-4.91,1.35s-3.55-.64-4.69-1.91c-1.14-1.28-1.7-3.08-1.7-5.4,0-2.19.62-3.97,1.86-5.35,1.25-1.38,2.79-2.08,4.63-2.08s3.27.6,4.27,1.79,1.51,2.85,1.51,4.96v1.18Zm-2.31-1.91c0-1.3-.33-2.31-.95-3.04-.61-.72-1.47-1.09-2.57-1.09s-1.97.38-2.71,1.14c-.74.76-1.2,1.75-1.37,2.98h7.6Zm17.71,8.38h-2.25v-2.39h-.05c-1.04,1.81-2.66,2.72-4.84,2.72-1.77,0-3.18-.63-4.25-1.88-1.05-1.26-1.58-2.98-1.58-5.15,0-2.33.59-4.19,1.76-5.59,1.17-1.4,2.74-2.1,4.69-2.1s3.34.76,4.22,2.28h.05v-8.71h2.25v20.84Zm-2.25-6.36v-2.08c0-1.14-.38-2.1-1.13-2.89-.75-.79-1.7-1.18-2.86-1.18-1.37,0-2.46.5-3.24,1.51-.79,1.01-1.18,2.4-1.18,4.18,0,1.62.38,2.9,1.13,3.85.76.93,1.78,1.4,3.05,1.4s2.27-.45,3.05-1.36c.79-.91,1.18-2.05,1.18-3.44Zm14.14-5.43c-.39-.3-.96-.45-1.7-.45-.96,0-1.77.45-2.42,1.36-.64.91-.96,2.14-.96,3.71v7.18h-2.25v-14.08h2.25v2.9h.05c.32-.99.81-1.76,1.47-2.31.66-.56,1.4-.84,2.21-.84.59,0,1.04.06,1.35.19v2.34Zm8.31,12.12c-2.08,0-3.74-.66-4.99-1.97-1.24-1.32-1.86-3.07-1.86-5.24,0-2.36.65-4.21,1.94-5.54,1.29-1.33,3.04-1.99,5.24-1.99s3.73.65,4.91,1.94c1.18,1.29,1.77,3.08,1.77,5.37s-.64,4.05-1.91,5.4c-1.26,1.35-2.96,2.02-5.1,2.02Zm.16-12.84c-1.45,0-2.59.49-3.44,1.48-.84.98-1.26,2.34-1.26,4.07s.43,2.98,1.28,3.94c.85.96,1.99,1.44,3.42,1.44s2.57-.47,3.35-1.42c.79-.94,1.18-2.29,1.18-4.03s-.39-3.12-1.18-4.07c-.78-.95-1.9-1.43-3.35-1.43Zm16.31,12.84c-2.08,0-3.74-.66-4.99-1.97-1.24-1.32-1.86-3.07-1.86-5.24,0-2.36.65-4.21,1.94-5.54,1.29-1.33,3.04-1.99,5.24-1.99s3.73.65,4.91,1.94c1.18,1.29,1.77,3.08,1.77,5.37s-.64,4.05-1.91,5.4c-1.26,1.35-2.96,2.02-5.1,2.02Zm.16-12.84c-1.45,0-2.59.49-3.44,1.48-.84.98-1.26,2.34-1.26,4.07s.43,2.98,1.28,3.94c.85.96,1.99,1.44,3.42,1.44s2.57-.47,3.35-1.42c.79-.94,1.18-2.29,1.18-4.03s-.39-3.12-1.18-4.07c-.78-.95-1.9-1.43-3.35-1.43Zm30.41,12.51h-2.25v-8.08c0-1.56-.24-2.68-.73-3.38-.48-.7-1.28-1.04-2.42-1.04-.96,0-1.78.44-2.46,1.32-.67.88-1,1.93-1,3.16v8.03h-2.25v-8.36c0-2.77-1.07-4.15-3.2-4.15-.99,0-1.81.42-2.45,1.25-.64.82-.96,1.9-.96,3.23v8.03h-2.25v-14.08h2.25v2.23h.05c1-1.7,2.46-2.56,4.37-2.56.96,0,1.8.27,2.52.81.71.53,1.21,1.23,1.47,2.1,1.04-1.94,2.6-2.91,4.67-2.91,3.1,0,4.65,1.91,4.65,5.73v8.67Z" />
				<path d="m642.2,324.67c0-.38.06-.76.18-1.14.12-.39.29-.75.51-1.08.23-.33.5-.64.83-.91.33-.27.71-.49,1.13-.65-.62-.35-1.11-.79-1.48-1.33-.37-.55-.55-1.15-.55-1.81,0-.53.1-1.01.3-1.46.21-.45.49-.83.85-1.16.36-.33.79-.58,1.28-.76.49-.19,1.03-.28,1.6-.28s1.12.09,1.61.28c.49.19.92.44,1.28.77.36.33.64.71.84,1.16.2.45.3.93.3,1.45,0,.66-.18,1.26-.55,1.81-.37.54-.85.98-1.46,1.33.41.16.78.38,1.11.65.33.27.6.58.82.91.23.33.4.69.52,1.08.12.38.18.76.18,1.14,0,.63-.11,1.2-.34,1.72-.23.52-.55.97-.96,1.34-.41.37-.9.65-1.47.86-.57.21-1.19.31-1.88.31s-1.3-.1-1.87-.31c-.57-.21-1.06-.49-1.47-.86-.41-.37-.74-.82-.97-1.34-.23-.52-.34-1.09-.34-1.72Zm1.78-.14c0,.45.07.85.2,1.21.14.36.33.67.58.92.25.25.56.45.91.59.36.13.76.2,1.19.2s.81-.07,1.16-.21c.35-.14.66-.34.91-.59.26-.25.46-.56.6-.92.15-.36.22-.76.22-1.2,0-.4-.07-.77-.21-1.12-.13-.35-.33-.66-.58-.93-.25-.27-.56-.48-.91-.63-.35-.15-.75-.23-1.19-.23-.41,0-.8.07-1.15.22-.35.14-.65.34-.91.6-.25.25-.45.56-.6.92-.15.35-.22.74-.22,1.17Zm.51-6.65c0,.34.06.66.18.95.13.29.3.54.51.76.22.21.47.38.76.51.29.12.59.18.92.18s.63-.06.92-.19c.29-.13.55-.3.76-.51.21-.22.38-.47.51-.76.13-.29.19-.61.19-.94s-.06-.67-.19-.96c-.12-.29-.29-.55-.5-.76s-.47-.38-.76-.5c-.29-.13-.6-.19-.93-.19-.35,0-.68.06-.97.19-.29.13-.54.3-.75.52-.21.21-.37.47-.48.76s-.17.61-.17.94Z" />
				<rect x="653.98" y="314.34" width="1.45" height="4.47" />
				<path d="m664.23,328.67h-1.64v-12.38c-.13.13-.31.27-.56.44-.24.16-.51.32-.82.48-.3.16-.62.31-.96.45-.33.14-.66.25-.98.33v-1.66c.36-.1.74-.23,1.14-.4.41-.17.8-.36,1.19-.57.39-.21.76-.43,1.11-.66.35-.23.65-.46.9-.68h.62v14.65Zm14.01-7.22c0,1.2-.11,2.26-.33,3.19-.21.93-.53,1.71-.94,2.35-.41.63-.91,1.12-1.51,1.45-.59.33-1.27.49-2.03.49-.72,0-1.36-.16-1.93-.47-.56-.32-1.03-.78-1.42-1.39s-.68-1.35-.88-2.23c-.2-.89-.3-1.9-.3-3.04,0-1.25.1-2.36.31-3.32.21-.96.52-1.76.93-2.41.41-.65.91-1.14,1.51-1.47.61-.33,1.3-.5,2.08-.5,3,0,4.51,2.45,4.51,7.34Zm-1.68.16c0-4.08-.97-6.12-2.91-6.12-2.05,0-3.07,2.08-3.07,6.23,0,3.87,1,5.81,3.01,5.81s2.97-1.97,2.97-5.92Z" />
				<path d="m682.18,314.34v4.47h-1.45v-4.47h1.45Zm3.32,0v4.47h-1.45v-4.47h1.45Z" />
				<path d="m701.88,318.44l-3.44,5.18,3.38,5.06h-1.91l-2.01-3.32c-.13-.21-.28-.47-.45-.78h-.04c-.03.06-.19.32-.47.78l-2.05,3.32h-1.89l3.49-5.02-3.34-5.22h1.91l1.98,3.5c.15.26.29.53.43.8h.04l2.56-4.3h1.81Z" />
				<path d="m715,328.67h-1.64v-12.38c-.13.13-.31.27-.56.44-.24.16-.51.32-.82.48-.3.16-.62.31-.96.45-.33.14-.66.25-.98.33v-1.66c.36-.1.74-.23,1.14-.4.41-.17.8-.36,1.19-.57.39-.21.76-.43,1.11-.66.35-.23.65-.46.9-.68h.62v14.65Zm14.03-4.55c0,.7-.11,1.34-.34,1.93-.23.59-.54,1.09-.94,1.52-.4.43-.88.76-1.43,1-.55.23-1.15.35-1.8.35-.72,0-1.37-.15-1.94-.45-.57-.3-1.05-.73-1.45-1.29-.39-.57-.69-1.26-.9-2.07-.21-.81-.31-1.73-.31-2.75,0-1.25.14-2.37.41-3.39.28-1.02.67-1.89,1.18-2.61.51-.73,1.13-1.29,1.85-1.68s1.52-.59,2.41-.59c.99,0,1.78.14,2.38.41v1.55c-.74-.38-1.52-.57-2.34-.57-.64,0-1.22.14-1.73.43-.51.29-.95.69-1.32,1.22-.37.52-.65,1.15-.85,1.89-.19.74-.29,1.56-.29,2.47h.04c.66-1.19,1.75-1.79,3.27-1.79.63,0,1.19.11,1.69.32.51.21.94.52,1.29.91.36.39.64.85.83,1.39.19.54.29,1.14.29,1.8Zm-1.68.21c0-.5-.06-.95-.19-1.35-.13-.4-.31-.74-.55-1.02-.23-.28-.52-.49-.87-.64-.35-.15-.74-.23-1.18-.23-.41,0-.78.08-1.13.23-.35.15-.65.36-.9.63-.25.26-.45.57-.6.92-.14.35-.21.72-.21,1.11,0,.49.07.96.21,1.39.14.43.34.8.59,1.12.25.32.55.57.9.76.35.18.74.27,1.17.27s.79-.08,1.13-.23c.34-.16.63-.38.87-.66s.43-.61.56-1c.13-.39.2-.83.2-1.3Z" />
				<rect x="731.5" y="314.34" width="1.45" height="4.47" />
				<path d="m744.55,320.65c0,1.31-.13,2.48-.39,3.51-.26,1.02-.64,1.89-1.14,2.6-.5.71-1.11,1.25-1.83,1.62-.72.37-1.54.55-2.46.55s-1.78-.17-2.5-.5v-1.57c.79.45,1.64.67,2.54.67.65,0,1.22-.13,1.73-.4.51-.27.95-.65,1.3-1.16.35-.51.62-1.14.81-1.89.19-.75.28-1.6.28-2.57h-.04c-.61,1.23-1.68,1.85-3.2,1.85-.61,0-1.18-.11-1.69-.32-.51-.22-.96-.53-1.33-.92-.37-.4-.66-.87-.87-1.42-.21-.55-.31-1.15-.31-1.81,0-.71.11-1.35.34-1.94.23-.59.55-1.09.96-1.51.41-.43.9-.76,1.46-.99.57-.23,1.18-.35,1.85-.35.72,0,1.36.15,1.91.44.56.29,1.03.71,1.41,1.27.38.55.67,1.24.87,2.05.2.81.3,1.74.3,2.79Zm-1.77-1.47c0-.55-.07-1.06-.22-1.51-.14-.45-.34-.84-.59-1.16-.25-.33-.56-.58-.91-.75-.35-.18-.73-.27-1.14-.27s-.76.08-1.1.24c-.34.15-.64.37-.89.66-.25.28-.44.62-.59,1.01-.14.39-.21.81-.21,1.27,0,.51.07.96.2,1.36.14.4.34.74.59,1.02.25.27.56.48.91.63.36.15.76.22,1.19.22.38,0,.74-.07,1.07-.21.34-.15.63-.34.88-.58.25-.25.45-.53.59-.86.15-.33.22-.69.22-1.07Z" />
				<path d="m748.65,314.34v4.47h-1.45v-4.47h1.45Zm3.32,0v4.47h-1.45v-4.47h1.45Z" />
				<path d="m547.25,733.04l-3.24,11.48h-1.58l-2.36-8.39c-.1-.36-.16-.75-.18-1.17h-.03c-.03.39-.1.78-.21,1.15l-2.38,8.4h-1.56l-3.36-11.48h1.48l2.44,8.8c.1.37.17.75.19,1.15h.04c.03-.28.11-.67.25-1.15l2.54-8.8h1.29l2.43,8.87c.09.3.15.66.19,1.07h.03c.02-.28.09-.65.22-1.1l2.35-8.84h1.46Z" />
				<polygon points="553.94 733.04 548.43 746.43 547.21 746.43 552.7 733.04 553.94 733.04" />
				<path d="m555.28,744.52v-11.48h3.17c4.04,0,6.07,1.87,6.07,5.6,0,1.77-.56,3.2-1.69,4.27-1.12,1.07-2.62,1.61-4.51,1.61h-3.04Zm1.34-10.26v9.05h1.71c1.5,0,2.68-.4,3.51-1.21.84-.81,1.26-1.95,1.26-3.43,0-2.94-1.56-4.41-4.69-4.41h-1.79Z" />
			</g>
		</g>
	)
}

export default PlanA
